var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayBlackItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:05:55 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-BlackItalic",
    horizAdvX: 596
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway Black",
    fontWeight: 900,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 10 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 526,
    capHeight: 710,
    bbox: "-224 -234 1336 930",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 672,
    d: "M86 322h-61l31 143h61l5 23q11 49 33 89.5t52.5 69t68.5 44t81 15.5q59 0 131 -30q31 30 69.5 47t84.5 17q59 0 133 -30l-62 -144q-15 6 -33 10t-30 4q-40 0 -50 -51l-14 -64h105l-30 -143h-105l-69 -322h-190l69 322h-90l-68 -322h-190zM396 465q4 18 7.5 36t6.5 36 q-12 4 -24 6.5t-23 2.5q-40 0 -50 -51l-6 -30h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 607,
    d: "M86 322h-61l31 143h61l12 57q10 49 36 89.5t63 69t83 44t96 15.5q55 0 103.5 -19.5t103.5 -60.5l-102 -144q-28 30 -61 47t-65 17q-26 0 -43.5 -12.5t-22.5 -38.5l-14 -64h288l-99 -465h-190l68 322h-97l-68 -322h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 692,
    d: "M481 -9q-66 0 -99.5 29.5t-33.5 72.5q0 12 3 24l76 356q4 20 6.5 36t2.5 28q0 22 -9 32.5t-32 10.5q-38 0 -56 -24t-26 -62l-6 -29h62l-30 -143h-63l-68 -322h-190l68 322h-61l31 143h61l16 75q11 52 37.5 90t64 62.5t84.5 36t101 11.5q111 0 161.5 -44.5t50.5 -120.5 q0 -15 -1.5 -31.5t-5.5 -33.5l-62 -293q-1 -5 -1.5 -10t-0.5 -10q0 -14 6 -25.5t23 -11.5q8 0 17.5 2.5t18.5 5.5t15 5.5t7 2.5l-10 -152q-2 -1 -16.5 -6.5t-37 -11.5t-49.5 -10.5t-54 -4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 887,
    d: "M86 322h-61l31 143h61l5 23q11 49 33 89.5t52.5 69t68.5 44t81 15.5q59 0 131 -30q37 30 87 47t108 17q48 0 100 -19t110 -61l-102 -144q-26 29 -59.5 46.5t-61.5 17.5q-60 0 -70 -51l-14 -64h288l-99 -465h-191l69 322h-97l-69 -322h-190l69 322h-90l-68 -322h-190z M396 465q4 18 7.5 36t6.5 36q-12 4 -24 6.5t-23 2.5q-40 0 -50 -51l-6 -30h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 970,
    d: "M759 -9q-66 0 -99.5 29.5t-33.5 72.5q0 12 3 24l78 366q3 14 5 27t2 24q0 22 -10.5 34t-37.5 12q-32 0 -50 -25.5t-25 -60.5l-6 -29h62l-30 -143h-63l-68 -322h-190l68 322h-88l-68 -322h-190l68 322h-61l31 143h61l5 23q11 49 33 89.5t52 69t67.5 44t79.5 15.5 q63 0 135 -30q39 33 92.5 48.5t116.5 15.5q111 0 161.5 -44.5t50.5 -120.5q0 -15 -1.5 -31.5t-5.5 -33.5l-63 -293q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -15 6.5 -26.5t23.5 -11.5q8 0 17.5 2.5t18.5 5.5t15 5.5l6 2.5l-9 -152q-2 -1 -16.5 -6.5t-37 -11.5t-50 -10.5t-53.5 -4.5z M395 465q4 18 7.5 36.5t6.5 36.5q-26 8 -46 8q-40 0 -50 -51l-6 -30h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 223
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 330,
    d: "M70 300l88 417h190l-88 -417h-190zM6 0l39 184h190l-39 -184h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 472,
    d: "M92 496l50 234h160l-50 -234h-160zM300 496l50 234h160l-50 -234h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 727,
    d: "M712 397h-153l-35 -87h121l-30 -140h-155l-75 -170h-150l75 170h-47l-74 -170h-151l75 170h-106l30 140h140l35 87h-108l28 130h140l81 183h151l-82 -183h47l81 183h151l-83 -183h122zM374 310l35 87h-47l-35 -87h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 630,
    d: "M524 478q-3 3 -14 10.5t-28 17t-39.5 19t-48.5 14.5l-19 -89l38 -13q35 -12 64.5 -27t51 -35.5t33.5 -48t12 -64.5q0 -71 -25 -120.5t-65 -81.5t-90.5 -48.5t-101.5 -19.5l-25 -121h-80l26 123q-63 6 -123.5 27t-105.5 53l120 170q2 -2 15 -12t35 -22t50.5 -23.5 t60.5 -16.5l18 86l-59 21q-67 24 -99 62t-32 95q0 61 23 110.5t61.5 85.5t87.5 57t101 27l22 101h79l-22 -102q30 -4 58.5 -12t53.5 -18.5t46.5 -22t38.5 -21.5zM354 204q0 19 -25 32l-14 -69q25 2 32 13t7 24zM307 501q0 -19 21 -31l16 71q-16 -3 -26.5 -13t-10.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 825,
    d: "M227 404q-32 0 -58 10t-44.5 28t-28.5 42t-10 52q0 37 17.5 70.5t46 59t66 40t78.5 14.5q31 0 57 -10t45 -28t29 -42t10 -52q0 -38 -17.5 -71t-46 -58.5t-66.5 -40t-78 -14.5zM246 494q10 0 20.5 7t19 19t14 27.5t5.5 32.5q0 21 -8 35.5t-22 14.5q-10 0 -20.5 -7t-19 -19 t-14 -27.5t-5.5 -32.5q0 -21 8 -35.5t22 -14.5zM554 -10q-32 0 -58 10t-44.5 28t-28.5 42t-10 52q0 37 17.5 70.5t46 59t66 40t78.5 14.5q31 0 57 -10t45 -28t29 -42t10 -52q0 -38 -17.5 -71t-46 -58.5t-66.5 -40t-78 -14.5zM573 80q10 0 20.5 7t18.5 19t13.5 27.5t5.5 32.5 q0 21 -7.5 35.5t-21.5 14.5q-10 0 -20.5 -7t-19 -19t-14 -27.5t-5.5 -32.5q0 -21 8 -35.5t22 -14.5zM68 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 728,
    d: "M390 37q-46 -24 -92 -35.5t-88 -11.5q-52 0 -89.5 16t-61.5 42t-35.5 59.5t-11.5 68.5q0 37 11.5 66.5t32 54t47.5 45t58 39.5q-21 36 -31 65t-10 61q0 47 19.5 86t52.5 67t75.5 43.5t87.5 15.5q33 0 63.5 -9t56 -27.5t43 -48t25.5 -69.5l-134 -50q-8 37 -26 52t-38 15 q-17 0 -32.5 -10.5t-15.5 -32.5q0 -10 4 -18.5t12 -19t20 -25.5t28 -38l106 -154q14 28 24.5 61t15.5 71h187l-15 -129h-61q-15 -34 -33.5 -63t-38.5 -55l117 -169h-248zM264 134q28 0 54 10l-78 118q-24 -16 -33.5 -31.5t-9.5 -35.5q0 -32 19 -46.5t48 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 264,
    d: "M92 496l50 234h160l-50 -234h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 336,
    d: "M26 266q0 65 19.5 127t53 123.5t79 124.5t98.5 131l132 -58q-54 -72 -93 -134t-63.5 -116t-36 -101t-11.5 -88q0 -63 14 -133.5t34 -140.5l-153 -67q-15 35 -28 75.5t-23 83.5t-16 87t-6 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 335,
    d: "M329 430q0 -69 -21.5 -134.5t-57 -127.5t-80 -120.5t-90.5 -113.5l-124 67q41 57 76.5 109t62 102.5t41.5 102.5t15 110q0 44 -5.5 89.5t-13.5 85t-16 69.5t-13 45l157 58q29 -85 49 -174t20 -168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 356,
    d: "M107 499l63 78l-64 21l40 77l64 -36l11 82h95l-24 -82l79 36l7 -77l-73 -21l31 -78l-78 -45l-29 83l-63 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 440,
    d: "M400 430v-150h-85v-95h-170v95h-85v150h85v95h170v-95h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 256,
    d: "M-26 -157l69 157h-57l40 184h156l-40 -184l-86 -157h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 398,
    d: "M26 191l36 170h299l-36 -170h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 254,
    d: "M-13 0l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 771,
    d: "M825 710l-644 -710h-209l644 710h209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 595,
    d: "M231 -10q-45 0 -81.5 17.5t-62 49t-39.5 74.5t-14 95q0 77 27 144.5t72.5 118t104.5 79.5t123 29q45 0 81.5 -17.5t62 -49t39.5 -75t14 -95.5q0 -77 -27.5 -144.5t-73 -117.5t-104.5 -79t-122 -29zM268 164q18 0 35 14.5t30.5 38.5t21.5 56t8 67q0 37 -10 60t-29 23 q-20 0 -37.5 -15t-31 -39.5t-21.5 -56.5t-8 -66q0 -37 11 -59.5t31 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 532,
    d: "M32 170h135l42 199q-11 -12 -31.5 -23.5t-44.5 -21.5t-48.5 -16t-42.5 -6l37 174q13 0 38.5 10.5t52.5 25t50.5 31t31.5 28.5h194l-85 -401h121l-36 -170h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 583,
    d: "M-31 0q10 50 26 88t39.5 68.5t56 54.5t76.5 46q60 30 94.5 48t52 30t22 21.5t4.5 22.5q0 38 -43 38q-29 0 -59.5 -17t-70.5 -55l-90 141q24 21 57 38.5t70.5 30t78.5 19.5t82 7q96 0 144 -38t48 -106q0 -38 -9.5 -66.5t-26.5 -52t-41 -43t-54 -38.5q-26 -16 -52.5 -32.5 t-57.5 -34.5h197l-36 -170h-508v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 561,
    d: "M158 -147q-73 0 -125.5 19.5t-90.5 60.5l125 138q23 -23 51 -33.5t66 -10.5q59 0 82 20.5t23 59.5q0 29 -25 42.5t-80 13.5h-30l28 132h34q48 0 80 22t32 58q0 40 -46 40q-31 0 -63 -17.5t-61 -52.5l-90 141q21 20 51.5 36.5t66 28.5t74.5 18.5t78 6.5q96 0 150.5 -40.5 t54.5 -107.5q0 -34 -13.5 -65.5t-36 -57.5t-52 -44t-60.5 -24q47 -9 73.5 -48.5t26.5 -94.5t-23.5 -99.5t-66 -76t-102 -48.5t-131.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 570,
    d: "M195 -3h-238l36 170l384 404h130l-86 -404h84l-36 -170h-84l-26 -124h-190zM253 167l26 120l-99 -120h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 540,
    d: "M152 -149q-75 0 -128 29t-74 83l129 120q20 -31 49.5 -48.5t59.5 -17.5q39 0 62.5 26t23.5 67q0 24 -11.5 39t-33.5 15q-18 0 -34.5 -9.5t-27.5 -25.5h-162q45 111 86.5 221t87.5 221h339l-37 -173h-202l-24 -77q7 3 16.5 4t20.5 1q42 0 75.5 -13.5t57.5 -37.5t36.5 -58 t12.5 -75q0 -63 -25 -116t-68.5 -92t-102 -61t-126.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 593,
    d: "M234 -10q-97 0 -146 64.5t-49 179.5q0 102 27 190t75.5 153t116.5 102t150 37q122 0 195 -96l-131 -122q-40 54 -102 54q-44 0 -75 -29.5t-45 -83.5q43 34 103 34q44 0 80 -14.5t61.5 -40t39 -60.5t13.5 -76q0 -59 -25.5 -112t-69 -93t-100 -63.5t-118.5 -23.5zM268 149 q16 0 33 9t30.5 24t22 34.5t8.5 40.5q0 29 -15.5 48t-41.5 19q-18 0 -34.5 -8t-29.5 -22t-21 -32.5t-8 -39.5q0 -30 15.5 -51.5t40.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 582,
    d: "M304 411h-249l37 173h548l-480 -710h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 591,
    d: "M229 -10q-44 0 -83 13.5t-67.5 39t-45 62t-16.5 81.5q0 37 11 67t28.5 53.5t37.5 41.5t38 31q-17 14 -26.5 40.5t-9.5 54.5q0 56 28 100t71 74t92.5 46t93.5 16q35 0 70.5 -11.5t64 -33.5t46.5 -55t18 -76q0 -24 -7.5 -48t-20.5 -44.5t-29 -36.5t-33 -26q17 -18 32.5 -50 t15.5 -75q0 -57 -26 -105.5t-68.5 -83.5t-98.5 -55t-116 -20zM265 163q34 0 57 25t23 60q0 53 -50 53q-35 0 -57.5 -24t-22.5 -59q0 -23 13.5 -39t36.5 -16zM324 442q20 0 39.5 16t19.5 46q0 17 -9.5 28t-27.5 11q-24 0 -40.5 -18t-16.5 -43q0 -20 10.5 -30t24.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 574,
    d: "M167 -155q-121 0 -196 96l131 122q40 -54 103 -54q43 0 74.5 29.5t45.5 83.5q-44 -34 -103 -34q-44 0 -80 14.5t-61.5 40t-39 60.5t-13.5 76q0 59 25.5 112t68.5 93t99.5 63.5t118.5 23.5q97 0 146 -64.5t49 -179.5q0 -102 -27 -190t-75.5 -153t-116 -102t-149.5 -37z M269 237q18 0 34.5 8t29.5 22t21 32.5t8 39.5q0 30 -15.5 51.5t-40.5 21.5q-16 0 -33 -9t-30.5 -24t-22 -34.5t-8.5 -40.5q0 -29 15.5 -48t41.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 299,
    d: "M80 335l39 184h154l-39 -184h-154zM9 0l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 301,
    d: "M81 335l39 184h154l-39 -184h-154zM-5 -157l69 157h-57l40 184h156l-40 -184l-86 -157h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 554,
    d: "M28 298l424 258v-202l-148 -95l148 -87v-212l-424 250v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 492,
    d: "M78 101v120h323v-120h-323zM78 331v120h323v-120h-323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 555,
    d: "M507 210l-424 -250v212l148 87l-148 95v202l424 -258v-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 482,
    d: "M81 259q4 21 10.5 41.5t18 39t30 35t47.5 31.5q39 19 65.5 34t43 29t24 27.5t7.5 28.5q0 19 -12 30t-30 11q-16 0 -29 -7t-23 -17t-18 -20.5t-14 -17.5l-103 86q37 61 97.5 95t129.5 34q32 0 63 -8.5t55 -28t39 -50t15 -73.5q0 -41 -8.5 -71.5t-23.5 -54.5t-35.5 -42 t-44.5 -33t-49 -26t-46 -22t-36 -23t-18 -28h-155zM29 0l35 164h155l-35 -164h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 820,
    d: "M588 64q20 0 39.5 20t34.5 52t24.5 72.5t9.5 82.5q0 56 -17.5 100.5t-49.5 76t-77.5 48.5t-102.5 17q-75 0 -140.5 -29t-113.5 -79t-76 -117t-28 -144q0 -113 59 -176.5t163 -63.5q36 0 71.5 9t81.5 29l7 -68q-86 -40 -174 -40q-65 0 -117.5 21.5t-89 60.5t-56.5 94.5 t-20 124.5q0 93 35.5 175t96.5 142.5t143.5 95.5t175.5 35q69 0 125 -19.5t95.5 -57t61.5 -92t22 -123.5q0 -62 -17 -120.5t-46.5 -104.5t-70 -74t-87.5 -28q-36 0 -58.5 17t-22.5 48v5t1 6q-42 -35 -77.5 -50.5t-73.5 -15.5q-75 0 -118.5 50.5t-43.5 133.5q0 58 21 110.5 t56.5 92.5t81.5 63.5t96 23.5q46 0 76.5 -20t37.5 -54l10 56h83l-59 -315q-2 -8 -3 -17t-1 -16q0 -17 8.5 -27.5t23.5 -10.5zM354 82q40 0 65.5 22.5t43.5 64.5l16 115q-2 32 -21.5 55.5t-54.5 23.5q-25 0 -49.5 -13.5t-44 -37.5t-31.5 -56.5t-12 -69.5q0 -21 4.5 -40 t15 -33t27.5 -22.5t41 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 667,
    d: "M148 710h397q30 0 52.5 -12.5t37.5 -32.5t22.5 -46.5t7.5 -54.5q0 -30 -9 -59.5t-26.5 -56.5t-43 -49t-58.5 -35q44 -14 68.5 -49.5t24.5 -89.5q0 -60 -24 -102.5t-64 -69.5t-93 -40t-110 -13h-333zM365 164q24 0 43.5 19.5t19.5 54.5q0 20 -8.5 32.5t-23.5 12.5h-144 l-25 -119h138zM402 435q10 0 20.5 3.5t19 11.5t14 21.5t5.5 34.5q0 20 -8.5 29t-21.5 9h-123l-24 -109h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 664,
    d: "M299 -6q-65 0 -115 25.5t-85 68t-53 97t-18 113.5q0 74 32.5 148t90 133.5t136 97t171.5 37.5q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27t-35.5 14t-37 4q-46 0 -81.5 -22t-59.5 -56t-36.5 -74.5t-12.5 -77.5q0 -29 7 -55.5t21 -46t35 -31t50 -11.5 q18 0 38.5 4.5t40 15t37 27t30.5 40.5l139 -95q-23 -39 -60.5 -70t-82 -52t-92.5 -32t-91 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 693,
    d: "M148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 546,
    d: "M148 710h464l-36 -170h-269l-25 -118h218l-33 -158h-219l-56 -264h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 711,
    d: "M466 60q-44 -34 -86 -49.5t-90 -15.5q-56 0 -104 19.5t-83 56.5t-55 90t-20 121q0 91 36.5 170t97.5 137.5t139 92t162 33.5q45 0 85 -10.5t72 -31t54 -49t33 -64.5l-168 -111q-11 42 -44 67.5t-76 25.5q-38 0 -72 -18.5t-60.5 -50t-42 -74.5t-15.5 -92q0 -63 30 -101 t85 -38q78 0 154 70h-116l29 140h284l-81 -378h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 724,
    d: "M148 710h195l-56 -262h212l56 262h195l-151 -710h-195l59 278h-212l-59 -278h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 488,
    d: "M89 -11q-85 0 -137 44l74 159q2 -2 10 -7t21.5 -10t31 -9t37.5 -4q28 0 46.5 10t32 32.5t24 58t21.5 86.5l77 361h195l-77 -361q-17 -81 -40 -147.5t-62 -113.5t-100 -73t-154 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 665,
    d: "M148 710h195l-57 -270l248 270h221l-311 -318l177 -392h-225l-104 261l-56 -56l-44 -205h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 564,
    d: "M148 710h195l-115 -540h299l-36 -170h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 820,
    d: "M148 710h213l65 -334l208 334h212l-151 -710h-195l79 374l-158 -263h-103l-46 263l-80 -374h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 725,
    d: "M148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 602,
    d: "M148 710h292q43 0 76.5 -17.5t57 -46t36 -65.5t12.5 -76q0 -52 -22.5 -103.5t-61 -92t-89.5 -66t-109 -25.5h-102l-46 -218h-195zM363 388q9 0 19.5 6t19 18.5t14.5 31.5t6 45q0 29 -10.5 40t-21.5 11h-83l-32 -152h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 737,
    d: "M466 31q-38 -17 -79.5 -26.5t-84.5 -9.5q-66 0 -117 24.5t-86.5 66t-53.5 95t-18 111.5q0 81 35.5 157t95 135t137.5 95t164 36q66 0 117 -25t85.5 -66.5t52.5 -95.5t18 -112q0 -85 -38.5 -163.5t-102.5 -138.5l78 -114h-182zM341 168q8 0 15 0.5t14 1.5l-88 130h181 l29 -42q20 33 30.5 71t10.5 74q0 28 -6.5 53t-20 44t-35.5 30.5t-52 11.5q-47 0 -83 -22t-60 -56.5t-36.5 -76t-12.5 -80.5q0 -27 6.5 -52.5t20 -44.5t35.5 -30.5t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 653,
    d: "M-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5t-21.5 14.5h-103l-32 -152h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    d: "M245 -9q-37 0 -75 6t-74 17t-69 26t-60 34l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5t99.5 55t112.5 19q37 0 71.5 -7.5t65 -19t56.5 -25 t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64q0 -76 -28.5 -127.5t-73.5 -83.5t-100.5 -46t-109.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 600,
    d: "M254 540h-191l36 170h576l-36 -170h-190l-115 -540h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 713,
    d: "M291 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 641,
    d: "M76 710h206l24 -465l220 465h205l-396 -710h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1002,
    d: "M69 710h211l35 -487l71 148l-36 339h178l10 -219l103 219h179l-183 -339l11 -148l240 487h213l-414 -710h-161l-39 254l-145 -254h-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 631,
    d: "M223 350l-146 360h211l67 -224l162 224h210l-299 -360l140 -350h-210l-61 214l-152 -214h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 627,
    d: "M198 237l-126 473h211l47 -307l181 307h212l-332 -475l-50 -235h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 593,
    d: "M-6 145l387 395h-288l36 170h514l-31 -145l-368 -395h290l-36 -170h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 346,
    d: "M-10 -40l166 780h242l-32 -150h-67l-102 -480h67l-31 -150h-243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 663,
    d: "M316 710l262 -710h-209l-263 710h210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 347,
    d: "M-31 -40l32 150h68l102 480h-68l32 150h242l-165 -780h-243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 630,
    d: "M44 303l198 407h158l197 -407h-153l-123 253l-126 -253h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 423,
    d: "M-55 -170l36 170h333l-36 -170h-333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 275,
    d: "M45 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 627,
    d: "M305 -10q-111 0 -139 92l-17 -82h-165l155 730h190l-60 -282q28 41 72.5 64.5t94.5 23.5q40 0 71.5 -15.5t53 -43.5t32.5 -67t11 -85q0 -70 -24.5 -131t-66 -106.5t-95.5 -71.5t-113 -26zM287 150q24 0 45 10.5t37 29t25.5 43.5t9.5 54q0 38 -17 63.5t-46 25.5 q-26 0 -55 -21.5t-49 -56.5l-20 -94q14 -27 29 -40.5t41 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 555,
    d: "M232 -10q-57 0 -99.5 18t-70.5 48t-42 70t-14 85q0 61 24 119.5t69 104t108 73.5t141 28q93 0 146 -40t71 -103l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5t-35 -29.5t-24.5 -45.5t-9 -58.5q0 -38 16.5 -60t44.5 -22q38 0 71 39l173 -56q-45 -63 -115 -103t-162 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 645,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l60 282h191l-111 -520q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-43 0 -70.5 16t-27.5 56q0 5 0.5 10t1.5 10 q-36 -48 -83.5 -70t-96.5 -22zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 394,
    d: "M86 322h-61l31 143h61l12 57q10 49 32 89.5t53 69t68.5 44t79.5 15.5q63 0 135 -30l-62 -144q-14 6 -32 10t-32 4q-41 0 -51 -51l-14 -64h108l-31 -143h-107l-114 -535h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 626,
    d: "M159 -223q-79 0 -133.5 26t-90.5 75l122 104q21 -27 55 -45.5t76 -18.5q24 0 47.5 7t43 22.5t34.5 40.5t22 60l7 34q-29 -42 -73.5 -62t-92.5 -20q-40 0 -71.5 15.5t-53 42.5t-32.5 64.5t-11 81.5q0 69 24 129.5t65 105.5t95.5 71t114.5 26q53 0 88.5 -22.5t49.5 -65.5 l17 78h165l-102 -478q-13 -62 -45.5 -112t-80.5 -85t-109 -54.5t-131 -19.5zM277 150q24 0 45.5 13.5t45.5 40.5l20 94q-5 36 -25 57t-46 21q-21 0 -40.5 -12t-35.5 -32t-25.5 -45.5t-9.5 -53.5q0 -37 19 -60t52 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 601,
    d: "M139 730h190l-60 -282q35 43 82 65.5t100 22.5q37 0 61.5 -9.5t38.5 -26t19.5 -37.5t5.5 -43q0 -19 -2.5 -38t-6.5 -36l-73 -346h-190l63 296q3 15 3 27q0 25 -11.5 36t-29.5 11q-8 0 -19.5 -5.5t-24.5 -15t-25.5 -23.5t-22.5 -31l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM139 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 290,
    d: "M-66 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16zM143 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 582,
    d: "M139 730h188l-71 -332q76 133 191 133q55 0 85 -32t30 -92q0 -67 -34 -123.5t-96 -94.5l77 -189h-200l-74 215q72 13 114.5 42t42.5 67q0 20 -12 32.5t-31 12.5q-17 0 -34.5 -10t-34 -27t-31.5 -40t-26 -49l-51 -243h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 345,
    d: "M132 -10q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l125 588h190l-111 -521q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-36 -16 -80 -25t-81 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 903,
    d: "M96 526h171l-17 -78q35 43 87.5 65.5t109.5 22.5q33 0 55 -7.5t35.5 -20t20 -29t8.5 -34.5q35 43 86.5 67t107.5 24q36 0 58.5 -10t36 -26t18.5 -37t5 -43q0 -9 -1.5 -27t-7.5 -47l-74 -346h-190l63 296q3 16 3 29q0 23 -9.5 34t-22.5 11q-10 0 -22.5 -6t-25 -16 t-24 -23.5t-20.5 -29.5l-62 -295h-190l63 296q3 16 3 29q0 23 -9.5 34t-23.5 11q-10 0 -22.5 -6t-25 -16t-24 -24t-19.5 -29l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 601,
    d: "M96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 626,
    d: "M95 526h165l-17 -79q35 43 78.5 66t100.5 23q42 0 75.5 -16t57 -44t36 -67t12.5 -85q0 -68 -23 -128.5t-62 -106t-89.5 -72.5t-104.5 -27t-88.5 22.5t-45.5 65.5l-62 -291h-190zM292 150q21 0 41 12t36 31.5t25.5 45.5t9.5 54q0 38 -18.5 60.5t-53.5 22.5 q-23 0 -44.5 -13.5t-45.5 -40.5l-20 -91q5 -35 24.5 -58t45.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 626,
    d: "M169 -10q-38 0 -68 15.5t-51 43.5t-32 66.5t-11 84.5q0 70 24.5 131.5t65.5 107t94.5 71.5t112.5 26q57 0 90 -24t50 -67l17 81h165l-110 -519q-3 -12 -3 -21q0 -28 38 -29l-34 -160q-26 -5 -55.5 -7.5t-51.5 -2.5q-48 0 -78.5 24.5t-30.5 67.5q0 11 3 25l37 174 q-29 -43 -73.5 -65.5t-98.5 -22.5zM278 150q43 0 90 54l20 94q-6 35 -25.5 56.5t-45.5 21.5q-21 0 -41.5 -12t-36 -31.5t-25 -45t-9.5 -53.5q0 -38 19 -61t54 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 408,
    d: "M96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 485,
    d: "M191 -10q-66 0 -124.5 22.5t-93.5 65.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61l-95 -114q-41 31 -69 45t-54 14q-17 0 -27 -8.5 t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -46 -18 -84t-51 -65t-79 -42t-102 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 415,
    d: "M172 -11q-27 0 -50 5.5t-40.5 18.5t-27 33t-9.5 50q0 11 1 22t4 24l51 241h-61l31 143h61l35 165h190l-35 -165h96l-30 -143h-97l-37 -174q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -29 30 -29q12 0 30.5 4.5t38.5 12.5v-150q-44 -17 -90.5 -28.5t-88.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 548,
    d: "M43 526h197v-377q30 55 52.5 100.5t41 88t35.5 87.5t36 101h170q-36 -131 -108.5 -263t-174.5 -263h-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 816,
    d: "M34 526h180l38 -353l52 113l-39 240h150l9 -154l75 154h140q-30 -72 -60 -127.5t-71 -112.5l7 -62q27 35 46.5 61.5t35 48t27.5 41.5t23.5 41.5t24 48t28.5 61.5h170q-54 -131 -143 -263t-210 -263h-109l-20 200l-105 -200h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 535,
    d: "M157 263l-109 263h192l38 -129l5 -21l13 21l97 129h190l-222 -263l115 -263h-193l-44 129l-4 20l-13 -20l-98 -129h-193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 543,
    d: "M-56 -93q28 0 48.5 2t36.5 7.5t28.5 14.5t24.5 24l29 34l-69 537h193l12 -365l34 56q36 60 65.5 139t46.5 170h182q-14 -48 -29 -90.5t-38 -89.5t-56.5 -105t-82.5 -138l-80 -129q-36 -58 -71.5 -97.5t-74 -64t-82 -35.5t-95.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 472,
    d: "M-18 112l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 360,
    d: "M325 590l-33 -154q-6 -28 -22 -45t-34 -31q9 -11 17.5 -25t8.5 -33q0 -5 -0.5 -9t-1.5 -9l-35 -165h52l-32 -150h-200q-5 0 -11 3.5t-6 16.5q0 6 1 10l47 220q1 5 1.5 8.5t0.5 8.5q0 25 -14 40.5t-30 19.5l27 130q10 0 22 6.5t22.5 17t19 24t11.5 27.5l44 209 q4 18 13.5 24t15.5 6h200l-32 -150h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 358,
    d: "M104 -130v905h160v-905h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 364,
    d: "M111 590l32 150h200q5 0 11 -4.5t6 -15.5q0 -6 -1 -10l-45 -209q-2 -10 -2 -15q0 -24 13.5 -42t31.5 -18l-28 -130q-21 -5 -44.5 -25t-30.5 -52l-46 -220q-4 -19 -14 -24.5t-15 -5.5h-200l32 150h52l35 165q6 27 22.5 44.5t33.5 31.5q-9 11 -17 24.5t-8 32.5v9.5t2 9.5 l33 154h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 587,
    d: "M32 216q0 12 8 38.5t27.5 53t51 46.5t79.5 20q30 0 54.5 -8t46.5 -17.5t43 -17.5t45 -8q22 0 36 7.5t21 16.5t9.5 17t2.5 10h100q0 -8 -8.5 -33.5t-28 -53.5t-52 -49.5t-81.5 -21.5q-29 0 -53 7.5t-46.5 16.5t-44 16.5t-45.5 7.5q-23 0 -36 -7t-19 -16t-7.5 -16.5 t-1.5 -8.5h-101v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 223
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 331,
    d: "M284 410l-89 -417h-190l89 417h190zM347 710l-39 -184h-190l39 184h190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 599,
    d: "M179 -120l24 111q-42 3 -75 23t-56 50.5t-35 69t-12 79.5q0 54 19 105.5t56 95t91.5 75.5t126.5 45l24 111h79l-24 -111q31 -1 60.5 -10t54 -26.5t43.5 -43.5t30 -61l-197 -56q-2 12 -10 21.5t-15 11.5l-46 -215q14 7 22.5 15.5t16.5 18.5l173 -56q-24 -36 -57 -63 t-67.5 -44.5t-67 -26.5t-55.5 -9l-24 -110h-79zM222 226q0 -17 4 -34t13 -28l42 197q-12 -8 -22.5 -22.5t-19 -33t-13 -39t-4.5 -40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 566,
    d: "M78 388h50l-8 54t-4 53q0 46 22 86.5t58 70t83.5 46.5t98.5 17q64 0 116.5 -27.5t83.5 -77.5l-120 -117q-18 29 -50.5 49t-62.5 20q-29 0 -46.5 -19t-17.5 -51q0 -22 5 -48.5t9 -55.5h182l-30 -140h-168q-24 -51 -81 -102q26 8 44 11.5t34 3.5q29 0 59 -7.5t60 -7.5 q16 0 29.5 3t31.5 10l16 -140q-24 -15 -58 -24.5t-63 -9.5q-22 0 -45 5t-46.5 11.5t-47.5 11.5t-48 5q-27 0 -66.5 -7.5t-78.5 -19.5l-9 134q31 18 60.5 51t46.5 72h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 586,
    d: "M200 507q22 11 47.5 16.5t55.5 5.5q29 0 54 -5.5t46 -14.5l68 69l71 -71l-63 -63q14 -23 22 -50t8 -56q0 -59 -31 -107l64 -64l-66 -66l-71 67q-42 -21 -102 -21q-59 0 -105 22l-72 -68l-66 66l66 66q-29 47 -29 105q0 28 7 54t21 49l-65 66l71 71zM230 338 q0 -37 20.5 -58t52.5 -21t52.5 21t20.5 58t-20.5 58t-52.5 21t-52.5 -21t-20.5 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 717,
    d: "M577 432h59l-25 -120h-121l-54 -77l-7 -33h159l-25 -120h-160l-17 -82h-194l17 82h-158l26 120h158l7 35l-20 75h-121l25 120h61l-71 278h211l48 -307l180 307h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 350,
    d: "M260 254v-384h-160v384h160zM260 775v-384h-160v384h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 535,
    d: "M457 232q7 -19 7 -56q0 -74 -29.5 -124.5t-73 -81.5t-93 -44.5t-88.5 -13.5q-41 0 -74.5 13t-58.5 31.5t-41 38t-22 32.5l146 116q17 -29 37.5 -40t42.5 -11q21 0 35 10t14 29q0 12 -8.5 15t-17.5 4q-45 4 -77.5 17t-53.5 33.5t-31 47.5t-10 57q0 24 4 41t9.5 28.5t10 19 t5.5 12.5q-3 8 -7 27t-4 44q0 43 21 86t56.5 76.5t83.5 54.5t102 21q47 0 80.5 -16t56.5 -39t37 -48t22 -44l-159 -68q-7 18 -19 32.5t-41 14.5q-45 0 -45 -41q0 -14 9 -17.5t20 -4.5q32 -2 65 -9.5t60 -24.5t44 -44.5t17 -67.5q0 -20 -4.5 -37t-10 -31t-10.5 -24zM243 307 q0 -11 5.5 -16t13 -7.5t16 -3.5t13.5 -3q6 5 9.5 13.5t3.5 16.5q0 14 -8.5 20t-16.5 6q-9 0 -17 2t-6 2q-5 -4 -9 -12t-4 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 556,
    d: "M73 580l30 140h156l-30 -140h-156zM298 580l30 140h155l-29 -140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 862,
    d: "M438 -7q-82 0 -152 27.5t-121 76t-79.5 114.5t-28.5 144q0 77 28.5 143t79.5 114t121 75.5t152 27.5q84 0 156 -27.5t124 -75.5t81.5 -114t29.5 -143q0 -78 -29.5 -144t-81.5 -114.5t-124 -76t-156 -27.5zM438 57q67 0 126 22t102 61t68 94t25 121q0 61 -24.5 115 t-67 94.5t-101.5 63.5t-128 23q-66 0 -123 -23t-99 -63.5t-65.5 -94.5t-23.5 -115q0 -62 23.5 -116.5t65 -95t98.5 -63.5t124 -23zM448 111q-65 0 -115.5 20t-84.5 53.5t-51.5 77.5t-17.5 92t17.5 92t51.5 77.5t84.5 53.5t115.5 20q92 0 154 -40t93 -103l-185 -56 q-23 39 -63 39q-30 0 -51.5 -21.5t-21.5 -61.5t21.5 -61.5t51.5 -21.5q40 0 63 39l185 -56q-31 -63 -93 -103t-154 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 434,
    d: "M155 333q-43 0 -68.5 26.5t-25.5 68.5q0 32 13.5 59t37 47t54.5 31.5t67 11.5q38 0 60 -14l2 11q1 5 1.5 9.5t0.5 8.5q0 17 -10 25.5t-33 8.5q-29 0 -54.5 -10t-55.5 -30l-20 82q75 47 161 47q69 0 104.5 -28t35.5 -84q0 -11 -1.5 -22t-3.5 -23l-15 -71q-1 -5 -1.5 -8 t-0.5 -6q0 -20 25 -21l-24 -112q-17 -4 -33.5 -5.5t-27.5 -1.5q-35 0 -50 12.5t-15 38.5v14q-29 -32 -60 -48.5t-63 -16.5zM214 428q7 0 16.5 3.5t18 9t15 12.5t8.5 15l6 27q-8 5 -18.5 7.5t-18.5 2.5q-21 0 -37.5 -14.5t-16.5 -34.5q0 -12 7.5 -20t19.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 693,
    d: "M30 298l307 198l-32 -152l-135 -85l100 -77l-32 -152l-227 180zM373 298l308 198l-33 -152l-134 -85l100 -77l-32 -152l-227 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 615,
    d: "M584 431l-73 -342h-160l37 172h-350l36 170h510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 609,
    d: "M26 191l36 170h510l-36 -170h-510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 862,
    d: "M440 -7q-83 0 -153.5 27.5t-121.5 76t-79.5 114.5t-28.5 144q0 77 28.5 143t79.5 114t121.5 75.5t153.5 27.5t154.5 -27.5t123.5 -75.5t81.5 -114t29.5 -143q0 -78 -29.5 -144t-81.5 -114.5t-123.5 -76t-154.5 -27.5zM441 56q66 0 123.5 22.5t100 62t66.5 93.5t24 118 q0 63 -23.5 117.5t-65.5 95t-99.5 63.5t-125.5 23t-125 -23t-98 -63.5t-64 -94.5t-23 -116t23 -116t64 -94.5t98 -64t125 -23.5zM270 572h199q31 0 58 -13t46 -34.5t30 -48.5t11 -54q0 -35 -17 -68t-45 -53l96 -157h-147l-81 131h-18v-131h-132v428zM455 387q11 0 20 7t9 28 q0 23 -10 29t-21 6h-51v-70h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 420,
    d: "M50 607l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 294,
    d: "M184 486q-44 0 -68.5 24.5t-24.5 66.5q0 28 11 54.5t30 47t45.5 33t57.5 12.5q44 0 69 -26t25 -67q0 -31 -11.5 -57.5t-31 -46t-46 -30.5t-56.5 -11zM203 573q13 0 24.5 12t11.5 27q0 14 -7.5 19t-15.5 5q-14 0 -25.5 -11t-11.5 -25q0 -11 6 -19t18 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 542,
    d: "M70 1v150h380v-150h-380zM451 462v-150h-105v-115h-170v115h-105v150h105v115h170v-115h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 427,
    d: "M42 376q9 43 21.5 74.5t32 56t48.5 43.5t71 36q27 11 52.5 20.5t45 21t31.5 25t12 31.5t-16.5 24.5t-42.5 6.5q-35 0 -67.5 -13.5t-55.5 -30.5l-51 80q29 29 84.5 49.5t127.5 20.5t109.5 -28.5t37.5 -85.5q0 -42 -15.5 -72t-38 -50t-49 -32t-48.5 -18q-34 -10 -57.5 -21 t-28.5 -31h174l-23 -107h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 407,
    d: "M203 369q-55 0 -90.5 17t-61.5 54l74 84q3 -3 9 -10.5t17 -15t29 -13.5t46 -6q15 0 30.5 2t27.5 6.5t20 11.5t8 18q0 22 -34.5 30t-97.5 8h-24l21 99h23q28 0 53 2.5t43.5 7.5t29 12.5t10.5 18.5q0 8 -6 13t-14 7.5t-18 3.5t-17 1q-37 0 -63 -12t-51 -32l-49 89 q32 28 82.5 42t98.5 14q72 0 114 -30t42 -76q0 -42 -33.5 -69.5t-81.5 -34.5q42 -7 61.5 -33.5t19.5 -62.5q0 -39 -20 -66.5t-51.5 -45t-70 -26t-76.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 274,
    d: "M143 576l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 668,
    d: "M108 526h190l-64 -303q-2 -8 -3 -15t-1 -13q0 -45 42 -45q14 0 36 10t51 44l68 322h190l-67 -316q-3 -12 -3 -21q0 -28 38 -29l-34 -160q-30 -5 -52.5 -7.5t-39.5 -2.5q-96 0 -96 73v19q-6 -11 -20.5 -26.5t-34 -30t-41 -25t-41.5 -10.5q-46 0 -46 36l-39 -239h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 683,
    d: "M60 377q0 76 23 137.5t66.5 105t105.5 67t139 23.5h332l-30 -140h-67l-138 -650h-160l57 268h-26l-57 -268h-160l57 268q-33 0 -59.5 14t-45 38.5t-28 59.5t-9.5 77zM218 387q0 -23 3.5 -40t10.5 -19l52 242q-10 -3 -21.5 -19.5t-21.5 -42t-16.5 -57.5t-6.5 -64zM470 570 h-27l-51 -242h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 254,
    d: "M36 238l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 350,
    d: "M26 -128q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5q-20 0 -43 -3.5t-34 -5.5l90 132l64 -19l-45 -51q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 312,
    d: "M329 485l-23 -107h-244l23 107h72l47 221q-7 -7 -19.5 -16t-26.5 -17.5t-28.5 -14t-25.5 -5.5l23 109q15 0 32.5 9t32.5 20t25.5 20t10.5 10h110l-72 -336h63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 424,
    d: "M218 333q-38 0 -65.5 12t-45.5 32.5t-27 48t-9 58.5q0 43 15.5 85t45 74t72 52t95.5 20q38 0 65.5 -12t45.5 -32.5t27 -47.5t9 -58q0 -44 -15.5 -85.5t-45 -74t-71.5 -52.5t-96 -20zM242 445q29 0 49.5 29.5t20.5 73.5q0 26 -9.5 40.5t-27.5 14.5q-29 0 -49.5 -29.5 t-20.5 -73.5q0 -26 10 -40.5t27 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 693,
    d: "M643 210l-303 -180l32 152l133 77l-99 85l33 152l223 -198zM300 210l-304 -180l32 152l133 77l-98 85l32 152l223 -198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 860,
    d: "M610 84h-203l23 107l290 250h74l-53 -250h61l-23 -107h-61l-18 -83h-107zM637 191l26 121l-133 -121h107zM318 395l-23 -107h-244l23 107h72l47 221q-7 -7 -19.5 -16t-26.5 -17.5t-28.5 -14t-25.5 -5.5l23 109q15 0 32.5 9t32.5 20t25.5 20t10.5 10h110l-72 -336h63z M112 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 895,
    d: "M435 0q9 43 20.5 74.5t30.5 56t47 43.5t69 36q26 11 50.5 20.5t43.5 21t30.5 25t11.5 31.5t-15.5 24.5t-41.5 6.5q-34 0 -65 -13.5t-53 -30.5l-50 80q27 29 81 49.5t125 20.5q68 0 104.5 -28.5t36.5 -85.5q0 -42 -15 -72t-37 -50t-47.5 -32t-46.5 -18q-32 -10 -55 -21 t-28 -31h186l-22 -107h-360zM318 395l-23 -107h-244l23 107h72l47 221q-7 -7 -19.5 -16t-26.5 -17.5t-28.5 -14t-25.5 -5.5l23 109q15 0 32.5 9t32.5 20t25.5 20t10.5 10h110l-72 -336h63zM77 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 880,
    d: "M194 279q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-49 89q32 28 82.5 42t100.5 14 q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8zM626 84h-203l23 107l290 250h74l-53 -250h61l-23 -107h-61l-18 -83h-107zM653 191l26 121l-133 -121h107zM151 65l337 319l308 337l67 -75 l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 476,
    d: "M378 247q-5 -21 -11 -41.5t-17.5 -39t-30 -35t-47.5 -31.5q-39 -19 -65.5 -34t-43 -29t-24 -27.5t-7.5 -28.5q0 -19 12 -30t30 -11q16 0 29 7t23 17t18 20.5t14 17.5l103 -86q-37 -61 -97.5 -95t-129.5 -34q-32 0 -63 8.5t-55 28t-39 49.5t-15 74q0 40 8.5 71t23.5 55 t35.5 42t44.5 33t49 26t46 22t36 22.5t18 28.5h155zM430 506l-35 -164h-155l35 164h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM303 917h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM460 762l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM253 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM481 758q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8 q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM227 767l30 140h156l-30 -140h-156zM452 767l30 140h155l-29 -140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM310 812q0 51 37.5 77.5t98.5 26.5q46 0 72 -17.5t26 -52.5q0 -51 -37.5 -77.5t-97.5 -26.5q-46 0 -72.5 17.5t-26.5 52.5zM434 862q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28 q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 935,
    d: "M478 710h505l-37 -170h-259l-20 -94h208l-36 -170h-208l-22 -106h267l-36 -170h-462l30 139h-187l-95 -139h-206zM429 309l39 186l-129 -186h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 664,
    d: "M196 -128q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5q-20 0 -43 -3.5t-34 -5.5l62 91q-59 4 -105.5 31t-78 69t-48 94.5t-16.5 108.5q0 74 32.5 148t90 133.5t136 97t171.5 37.5q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27 t-35.5 14t-37 4q-46 0 -81.5 -22t-59.5 -56t-36.5 -74.5t-12.5 -77.5q0 -29 7 -55.5t21 -46t35 -31t50 -11.5q18 0 38.5 4.5t40 15t37 27t30.5 40.5l139 -95q-20 -34 -50.5 -61.5t-67 -47.5t-77 -33.5t-79.5 -18.5l-28 -32q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5 q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM293 917h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 575,
    d: "M431 762l-128 12l77 142h168zM148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 575,
    d: "M216 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 575,
    d: "M203 767l30 140h156l-30 -140h-156zM428 767l30 140h155l-29 -140h-156zM148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM155 917h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM291 762l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM92 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM68 767l30 140h156l-30 -140h-156zM293 767l30 140h155l-29 -140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 696,
    d: "M57 427h34l60 283h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262l61 287h-33zM298 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-24 -113h104l-30 -140h-104l-25 -117h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 725,
    d: "M148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195zM523 758q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5 t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5zM360 917h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 738,
    d: "M519 762l-128 12l77 142h168zM303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5 q0 28 -6.5 53t-20 44t-35.5 30t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 738,
    d: "M300 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5 t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5zM536 758q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5 t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 738,
    d: "M278 767l30 140h156l-30 -140h-156zM503 767l30 140h155l-29 -140h-156zM303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167 q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 506,
    d: "M450 191l-119 -118l-87 87l-87 -87l-117 118l86 86l-80 81l119 118l80 -80l80 80l117 -118l-80 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 738,
    d: "M807 710l-116 -128q20 -37 31 -79t11 -87q0 -80 -35 -156t-94 -135t-137 -95t-164 -36q-68 0 -122 26l-18 -20h-209l115 127q-41 74 -41 165q0 81 35 157t94.5 135t138 94.5t164.5 35.5q33 0 62.5 -7t55.5 -19l20 22h209zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5 v6l-218 -240q6 -1 12 -1.5t13 -0.5zM228 302l215 237q-5 1 -11 1.5t-12 0.5q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5v-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM350 917h168 l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 712,
    d: "M501 762l-128 12l77 142h168zM290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5 t-111.5 -74t-141.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 712,
    d: "M284 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365 q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 712,
    d: "M262 767l30 140h156l-30 -140h-156zM487 767l30 140h155l-29 -140h-156zM290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195 l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 627,
    d: "M198 237l-126 473h211l47 -307l181 307h212l-332 -475l-50 -235h-194zM447 762l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 585,
    d: "M148 710h195l-25 -118h82q43 0 77 -17.5t57.5 -46t36 -65t12.5 -75.5q0 -53 -22.5 -104t-61 -92t-89.5 -66t-109 -25h-88l-21 -101h-195zM327 271q9 0 19.5 7.5t19 20.5t14.5 30.5t6 38.5q0 26 -10 40t-22 14h-72l-32 -151h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 546,
    d: "M219 168q18 0 34.5 5.5t29.5 16t21 25.5t8 35q0 14 -5 24t-12.5 16.5t-15.5 9.5t-13 3h-22l36 170h20q13 0 21 5.5t12.5 13t6 16t1.5 14.5q0 15 -8 23.5t-20 8.5q-18 0 -28 -15.5t-16 -44.5l-105 -494h-180l112 529q9 40 34 73.5t61.5 58.5t81.5 39t94 14q74 0 119 -35.5 t45 -100.5q0 -30 -9 -57.5t-23.5 -51t-32.5 -40.5t-35 -26q38 -17 59 -54.5t21 -90.5q0 -78 -31.5 -129t-79.5 -81t-106 -42t-112 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM207 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM373 576l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM151 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM384 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5 t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM133 580l30 140h156l-30 -140h-156zM358 580l30 140h155l-29 -140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM216 626q0 51 37.5 77.5t98.5 26.5q46 0 72 -17.5t26 -52.5q0 -51 -37.5 -77.5t-97.5 -26.5q-46 0 -72.5 17.5t-26.5 52.5z M340 676q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 902,
    d: "M130 -10q-66 0 -105 39t-39 101q0 44 20.5 82.5t55.5 66.5t82 44t101 16q60 0 94 -20q2 10 3.5 20.5t1.5 19.5q0 25 -16.5 37t-53.5 12q-42 0 -81.5 -14.5t-84.5 -42.5l-30 118q113 67 242 67q110 0 166 -50q37 23 80.5 36.5t94.5 13.5q57 0 99.5 -17.5t70.5 -47.5 t41.5 -69.5t13.5 -83.5q0 -39 -8.5 -66t-16.5 -47h-343q-1 -5 -1.5 -9t-0.5 -10q0 -32 19.5 -46t45.5 -14t54 14t41 39l151 -46q-45 -63 -117 -103t-165 -40q-77 0 -127 28t-74 74q-24 -27 -52 -46.5t-56 -31.5t-55.5 -18t-50.5 -6zM219 126q23 0 49.5 9.5t46.5 23.5 q-1 4 -1 8v8q0 11 1 22t3 25q-14 6 -31.5 10t-31.5 4q-16 0 -31 -5.5t-27 -15t-19 -22t-7 -26.5q0 -18 12 -29.5t36 -11.5zM686 319q0 5 0.5 7t0.5 9q0 30 -15 48t-43 18q-31 0 -55 -22t-36 -60h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 555,
    d: "M121 -128q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5q-20 0 -43 -3.5t-34 -5.5l59 88q-49 5 -85 24.5t-60 49t-35.5 67t-11.5 78.5q0 61 24 119.5t69 104t108 73.5t141 28q93 0 146 -40t71 -103l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5 t-35 -29.5t-24.5 -45.5t-9 -58.5q0 -38 16.5 -60t44.5 -22q38 0 71 39l173 -56q-41 -57 -100.5 -95t-137.5 -46l-23 -26q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM256 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 566,
    d: "M402 576l-128 12l77 142h168zM233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45 t-78.5 -29t-82 -10zM320 401q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 566,
    d: "M198 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48 q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 566,
    d: "M175 580l30 140h156l-30 -140h-156zM400 580l30 140h155l-29 -140h-156zM233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54 l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM98 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 286,
    d: "M248 576l-128 12l77 142h168zM96 526h190l-112 -526h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 286,
    d: "M40 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM96 526h190l-112 -526h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 286,
    d: "M13 580l30 140h156l-30 -140h-156zM238 580l30 140h155l-29 -140h-156zM96 526h190l-112 -526h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 603,
    d: "M605 641l-72 -35q25 -49 38.5 -107t13.5 -120q0 -88 -25 -159.5t-71 -122.5t-111 -79t-144 -28q-53 0 -95.5 15t-72.5 41.5t-46 63.5t-16 81q0 57 23.5 108t62.5 89t90 60.5t106 22.5q35 0 66.5 -12t54.5 -34q-2 34 -9 64q-4 14 -9 27.5t-11 27.5l-73 -34l-37 71l66 32 q-26 32 -61.5 60.5t-80.5 56.5h228q19 -10 36 -24.5t33 -32.5l79 39zM202 216q0 -30 17 -48t49 -18q44 0 72.5 29.5t28.5 74.5q0 30 -16.5 48t-48.5 18q-45 0 -73.5 -29.5t-28.5 -74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 601,
    d: "M96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190zM430 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5 t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22zM270 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    d: "M414 576l-128 12l77 142h168zM232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5 t8.5 57.5q0 38 -16 60t-45 22q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    d: "M200 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150 q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22zM426 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17 t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    d: "M174 580l30 140h156l-30 -140h-156zM399 580l30 140h155l-29 -140h-156zM232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74 t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 505,
    d: "M176 435v160h159v-160h-159zM176 27v160h159v-160h-159zM53 235v150h404v-150h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    d: "M42 80q-18 28 -26.5 60.5t-8.5 68.5q0 61 23.5 120t68 105t107.5 74t142 28q43 0 77.5 -10t60.5 -28l37 34h101l-90 -82q39 -56 39 -133q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28q-90 0 -144 42l-41 -38h-99zM266 150q22 0 42 11t35 30t24 45.5t9 57.5v6.5t-1 6.5 l-149 -142q15 -15 40 -15zM205 227l144 137q-15 12 -35 12q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5v-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM254 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 618,
    d: "M398 576l-128 12l77 142h168zM132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5 t1.5 9.5q-45 -49 -97.5 -70.5t-115.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 618,
    d: "M191 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10 q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5t-115.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 618,
    d: "M160 580l30 140h156l-30 -140h-156zM385 580l30 140h155l-29 -140h-156zM132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10 q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5t-115.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 543,
    d: "M-56 -93q28 0 48.5 2t36.5 7.5t28.5 14.5t24.5 24l29 34l-69 537h193l12 -365l34 56q36 60 65.5 139t46.5 170h182q-14 -48 -29 -90.5t-38 -89.5t-56.5 -105t-82.5 -138l-80 -129q-36 -58 -71.5 -97.5t-74 -64t-82 -35.5t-95.5 -11zM372 576l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 575,
    d: "M134 710h195l-39 -185q13 19 64 19q50 0 87.5 -18.5t62.5 -49.5t37.5 -71t12.5 -82q0 -60 -23.5 -122.5t-65.5 -114t-101 -84.5t-130 -33q-27 0 -40.5 4.5t-18.5 12.5l-42 -199h-195zM262 139q25 0 44.5 14.5t33 38.5t21 54t7.5 61q0 35 -13.5 51t-35.5 16 q-20 0 -38 -12.5t-33 -34.5l-33 -153q0 -12 11 -23.5t36 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 543,
    d: "M-56 -93q28 0 48.5 2t36.5 7.5t28.5 14.5t24.5 24l29 34l-69 537h193l12 -365l34 56q36 60 65.5 139t46.5 170h182q-14 -48 -29 -90.5t-38 -89.5t-56.5 -105t-82.5 -138l-80 -129q-36 -58 -71.5 -97.5t-74 -64t-82 -35.5t-95.5 -11zM146 580l30 140h156l-30 -140h-156z M371 580l30 140h155l-29 -140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM275 793l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM178 607l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM423 835q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM328 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98 q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 636,
    d: "M498 -215q-68 8 -99.5 32.5t-31.5 56.5q0 31 27.5 64t81.5 62h-96l-7 139h-170l-65 -139h-199l381 710h179l79 -710q-40 -23 -62.5 -44t-22.5 -39q0 -14 14.5 -23t46.5 -9zM370 269l-8 220l-103 -220h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 646,
    d: "M470 -215q-68 8 -99.5 32.5t-31.5 56.5q0 29 24 60t71 59q-29 5 -45.5 22.5t-16.5 51.5q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191 l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-40 -23 -62.5 -44t-22.5 -39q0 -14 14.5 -23t46.5 -9zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 664,
    d: "M531 762l-128 12l77 142h168zM299 -6q-65 0 -115 25.5t-85 68t-53 97t-18 113.5q0 74 32.5 148t90 133.5t136 97t171.5 37.5q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27t-35.5 14t-37 4q-46 0 -81.5 -22t-59.5 -56t-36.5 -74.5t-12.5 -77.5 q0 -29 7 -55.5t21 -46t35 -31t50 -11.5q18 0 38.5 4.5t40 15t37 27t30.5 40.5l139 -95q-23 -39 -60.5 -70t-82 -52t-92.5 -32t-91 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 555,
    d: "M401 576l-128 12l77 142h168zM232 -10q-57 0 -99.5 18t-70.5 48t-42 70t-14 85q0 61 24 119.5t69 104t108 73.5t141 28q93 0 146 -40t71 -103l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5t-35 -29.5t-24.5 -45.5t-9 -58.5q0 -38 16.5 -60t44.5 -22q38 0 71 39l173 -56 q-45 -63 -115 -103t-162 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 664,
    d: "M299 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM299 -6q-65 0 -115 25.5t-85 68t-53 97t-18 113.5q0 74 32.5 148t90 133.5t136 97t171.5 37.5q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27t-35.5 14t-37 4q-46 0 -81.5 -22t-59.5 -56t-36.5 -74.5 t-12.5 -77.5q0 -29 7 -55.5t21 -46t35 -31t50 -11.5q18 0 38.5 4.5t40 15t37 27t30.5 40.5l139 -95q-23 -39 -60.5 -70t-82 -52t-92.5 -32t-91 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 555,
    d: "M195 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM232 -10q-57 0 -99.5 18t-70.5 48t-42 70t-14 85q0 61 24 119.5t69 104t108 73.5t141 28q93 0 146 -40t71 -103l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5t-35 -29.5t-24.5 -45.5t-9 -58.5q0 -38 16.5 -60 t44.5 -22q38 0 71 39l173 -56q-45 -63 -115 -103t-162 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 664,
    d: "M299 -6q-65 0 -115 25.5t-85 68t-53 97t-18 113.5q0 74 32.5 148t90 133.5t136 97t171.5 37.5q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27t-35.5 14t-37 4q-46 0 -81.5 -22t-59.5 -56t-36.5 -74.5t-12.5 -77.5q0 -29 7 -55.5t21 -46t35 -31t50 -11.5 q18 0 38.5 4.5t40 15t37 27t30.5 40.5l139 -95q-23 -39 -60.5 -70t-82 -52t-92.5 -32t-91 -11zM385 766l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 555,
    d: "M232 -10q-57 0 -99.5 18t-70.5 48t-42 70t-14 85q0 61 24 119.5t69 104t108 73.5t141 28q93 0 146 -40t71 -103l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5t-35 -29.5t-24.5 -45.5t-9 -58.5q0 -38 16.5 -60t44.5 -22q38 0 71 39l173 -56q-45 -63 -115 -103t-162 -40z M272 580l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 664,
    d: "M311 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM299 -6q-65 0 -115 25.5t-85 68t-53 97t-18 113.5q0 74 32.5 148t90 133.5t136 97t171.5 37.5q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27t-35.5 14t-37 4q-46 0 -81.5 -22t-59.5 -56t-36.5 -74.5 t-12.5 -77.5q0 -29 7 -55.5t21 -46t35 -31t50 -11.5q18 0 38.5 4.5t40 15t37 27t30.5 40.5l139 -95q-23 -39 -60.5 -70t-82 -52t-92.5 -32t-91 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 555,
    d: "M202 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM232 -10q-57 0 -99.5 18t-70.5 48t-42 70t-14 85q0 61 24 119.5t69 104t108 73.5t141 28q93 0 146 -40t71 -103l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5t-35 -29.5t-24.5 -45.5t-9 -58.5q0 -38 16.5 -60t44.5 -22 q38 0 71 39l173 -56q-45 -63 -115 -103t-162 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 693,
    d: "M250 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 645,
    d: "M680 588l77 142h168l-132 -174zM193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l60 282h191l-111 -520q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-43 0 -70.5 16t-27.5 56 q0 5 0.5 10t1.5 10q-36 -48 -83.5 -70t-96.5 -22zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 696,
    d: "M57 427h34l60 283h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262l61 287h-33zM298 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-24 -113h104l-30 -140h-104l-25 -117h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 645,
    d: "M401 688h70l9 42h191l-9 -42h64l-24 -109h-63l-79 -369q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-96 0 -96 73v19q-36 -48 -83.5 -70t-96.5 -22q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5 q48 0 82.5 -23t46.5 -65l28 131h-70zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM252 793l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM219 607l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM400 835q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM369 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM307 766l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM276 580l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-184q-39 -22 -61 -43t-22 -39q0 -14 14.5 -23t46.5 -9l-56 -100q-68 8 -99.5 32.5t-31.5 56.5q0 31 27 63.5t80 61.5h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 566,
    d: "M216 -219q-68 8 -99.5 32.5t-31.5 56.5q0 30 26.5 62t77.5 61q-85 13 -133.5 71t-48.5 149q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-36 -52 -95 -88 t-125 -48q-40 -23 -62.5 -44t-22.5 -39q0 -14 14.5 -23t46.5 -9zM320 401q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 575,
    d: "M234 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 566,
    d: "M202 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48 q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 711,
    d: "M304 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM466 60q-44 -34 -86 -49.5t-90 -15.5q-56 0 -104 19.5t-83 56.5t-55 90t-20 121q0 91 36.5 170t97.5 137.5t139 92t162 33.5q45 0 85 -10.5t72 -31t54 -49t33 -64.5l-168 -111q-11 42 -44 67.5t-76 25.5 q-38 0 -72 -18.5t-60.5 -50t-42 -74.5t-15.5 -92q0 -63 30 -101t85 -38q78 0 154 70h-116l29 140h284l-81 -378h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 626,
    d: "M185 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM159 -223q-79 0 -133.5 26t-90.5 75l122 104q21 -27 55 -45.5t76 -18.5q24 0 47.5 7t43 22.5t34.5 40.5t22 60l7 34q-29 -42 -73.5 -62t-92.5 -20q-40 0 -71.5 15.5t-53 42.5t-32.5 64.5t-11 81.5q0 69 24 129.5 t65 105.5t95.5 71t114.5 26q53 0 88.5 -22.5t49.5 -65.5l17 78h165l-102 -478q-13 -62 -45.5 -112t-80.5 -85t-109 -54.5t-131 -19.5zM277 150q24 0 45.5 13.5t45.5 40.5l20 94q-5 36 -25 57t-46 21q-21 0 -40.5 -12t-35.5 -32t-25.5 -45.5t-9.5 -53.5q0 -37 19 -60t52 -23z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 711,
    d: "M466 60q-44 -34 -86 -49.5t-90 -15.5q-56 0 -104 19.5t-83 56.5t-55 90t-20 121q0 91 36.5 170t97.5 137.5t139 92t162 33.5q45 0 85 -10.5t72 -31t54 -49t33 -64.5l-168 -111q-11 42 -44 67.5t-76 25.5q-38 0 -72 -18.5t-60.5 -50t-42 -74.5t-15.5 -92q0 -63 30 -101 t85 -38q78 0 154 70h-116l29 140h284l-81 -378h-160zM480 835q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 626,
    d: "M159 -223q-79 0 -133.5 26t-90.5 75l122 104q21 -27 55 -45.5t76 -18.5q24 0 47.5 7t43 22.5t34.5 40.5t22 60l7 34q-29 -42 -73.5 -62t-92.5 -20q-40 0 -71.5 15.5t-53 42.5t-32.5 64.5t-11 81.5q0 69 24 129.5t65 105.5t95.5 71t114.5 26q53 0 88.5 -22.5t49.5 -65.5 l17 78h165l-102 -478q-13 -62 -45.5 -112t-80.5 -85t-109 -54.5t-131 -19.5zM277 150q24 0 45.5 13.5t45.5 40.5l20 94q-5 36 -25 57t-46 21q-21 0 -40.5 -12t-35.5 -32t-25.5 -45.5t-9.5 -53.5q0 -37 19 -60t52 -23zM364 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5 t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 711,
    d: "M466 60q-44 -34 -86 -49.5t-90 -15.5q-56 0 -104 19.5t-83 56.5t-55 90t-20 121q0 91 36.5 170t97.5 137.5t139 92t162 33.5q45 0 85 -10.5t72 -31t54 -49t33 -64.5l-168 -111q-11 42 -44 67.5t-76 25.5q-38 0 -72 -18.5t-60.5 -50t-42 -74.5t-15.5 -92q0 -63 30 -101 t85 -38q78 0 154 70h-116l29 140h284l-81 -378h-160zM387 766l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 626,
    d: "M159 -223q-79 0 -133.5 26t-90.5 75l122 104q21 -27 55 -45.5t76 -18.5q24 0 47.5 7t43 22.5t34.5 40.5t22 60l7 34q-29 -42 -73.5 -62t-92.5 -20q-40 0 -71.5 15.5t-53 42.5t-32.5 64.5t-11 81.5q0 69 24 129.5t65 105.5t95.5 71t114.5 26q53 0 88.5 -22.5t49.5 -65.5 l17 78h165l-102 -478q-13 -62 -45.5 -112t-80.5 -85t-109 -54.5t-131 -19.5zM277 150q24 0 45.5 13.5t45.5 40.5l20 94q-5 36 -25 57t-46 21q-21 0 -40.5 -12t-35.5 -32t-25.5 -45.5t-9.5 -53.5q0 -37 19 -60t52 -23zM272 580l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 711,
    d: "M205 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM466 60q-44 -34 -86 -49.5t-90 -15.5q-56 0 -104 19.5t-83 56.5t-55 90t-20 121q0 91 36.5 170t97.5 137.5t139 92t162 33.5q45 0 85 -10.5t72 -31t54 -49t33 -64.5l-168 -111q-11 42 -44 67.5t-76 25.5 q-38 0 -72 -18.5t-60.5 -50t-42 -74.5t-15.5 -92q0 -63 30 -101t85 -38q78 0 154 70h-116l29 140h284l-81 -378h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 626,
    d: "M159 -223q-79 0 -133.5 26t-90.5 75l122 104q21 -27 55 -45.5t76 -18.5q24 0 47.5 7t43 22.5t34.5 40.5t22 60l7 34q-29 -42 -73.5 -62t-92.5 -20q-40 0 -71.5 15.5t-53 42.5t-32.5 64.5t-11 81.5q0 69 24 129.5t65 105.5t95.5 71t114.5 26q53 0 88.5 -22.5t49.5 -65.5 l17 78h165l-102 -478q-13 -62 -45.5 -112t-80.5 -85t-109 -54.5t-131 -19.5zM277 150q24 0 45.5 13.5t45.5 40.5l20 94q-5 36 -25 57t-46 21q-21 0 -40.5 -12t-35.5 -32t-25.5 -45.5t-9.5 -53.5q0 -37 19 -60t52 -23zM443 745l-49 -61h57l-23 -106h-156l22 106l67 61h82z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 724,
    d: "M293 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM148 710h195l-56 -262h212l56 262h195l-151 -710h-195l59 278h-212l-59 -278h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 601,
    d: "M320 615l123 114h126l78 -114l-97 -41l-63 62l-87 -62zM139 730h190l-60 -282q35 43 82 65.5t100 22.5q37 0 61.5 -9.5t38.5 -26t19.5 -37.5t5.5 -43q0 -19 -2.5 -38t-6.5 -36l-73 -346h-190l63 296q3 15 3 27q0 25 -11.5 36t-29.5 11q-8 0 -19.5 -5.5t-24.5 -15 t-25.5 -23.5t-22.5 -31l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 729,
    d: "M86 626h47l18 84h195l-18 -84h212l18 84h195l-18 -84h47l-18 -88h-48l-114 -538h-195l59 278h-212l-59 -278h-195l114 538h-47zM502 448l19 90h-212l-19 -90h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 601,
    d: "M84 688h46l9 42h190l-9 -42h89l-23 -109h-89l-28 -131q35 43 82 65.5t100 22.5q37 0 61.5 -9.5t38.5 -26t19.5 -37.5t5.5 -43q0 -19 -2.5 -38t-6.5 -36l-73 -346h-190l63 296q3 15 3 27q0 25 -11.5 36t-29.5 11q-8 0 -19.5 -5.5t-24.5 -15t-25.5 -23.5t-22.5 -31 l-63 -295h-190l123 579h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM326 758q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5 t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM268 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5 t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM116 793l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM60 607l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM272 835q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM208 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 317,
    d: "M148 710h195l-151 -709q-41 -23 -63 -44t-22 -39q0 -14 14.5 -23t46.5 -9l-56 -100q-68 8 -99.5 32.5t-31.5 56.5q0 31 27 63.5t80 61.5h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526q-42 -22 -64 -43t-22 -39q0 -14 14.5 -23t46.5 -9l-56 -100q-68 8 -99.5 32.5t-31.5 56.5q0 31 27 63.5t80 61.5h-85zM139 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM175 766l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 805,
    d: "M148 710h195l-151 -710h-195zM406 -11q-85 0 -137 44l74 159q2 -2 10 -7t21.5 -10t31 -9t37.5 -4q28 0 46.5 10t32 32.5t24 58t21.5 86.5l77 361h195l-77 -361q-17 -81 -40 -147.5t-62 -113.5t-100 -73t-154 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 576,
    d: "M96 526h190l-112 -526h-190zM139 730h190l-34 -160h-190zM220 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16zM429 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 488,
    d: "M266 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM89 -11q-85 0 -137 44l74 159q2 -2 10 -7t21.5 -10t31 -9t37.5 -4q28 0 46.5 10t32 32.5t24 58t21.5 86.5l77 361h195l-77 -361q-17 -81 -40 -147.5t-62 -113.5t-100 -73t-154 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 286,
    d: "M-70 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16zM31 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 665,
    d: "M203 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM148 710h195l-57 -270l248 270h221l-311 -318l177 -392h-225l-104 261l-56 -56l-44 -205h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 582,
    d: "M145 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM139 730h188l-71 -332q76 133 191 133q55 0 85 -32t30 -92q0 -67 -34 -123.5t-96 -94.5l77 -189h-200l-74 215q72 13 114.5 42t42.5 67q0 20 -12 32.5t-31 12.5q-17 0 -34.5 -10t-34 -27t-31.5 -40t-26 -49 l-51 -243h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 564,
    d: "M96 526h190l-42 -195l163 195h199l-218 -230l125 -296h-201l-67 192l-39 -42l-32 -150h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 564,
    d: "M295 762l-128 12l77 142h168zM148 710h195l-115 -540h299l-36 -170h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 345,
    d: "M275 737l-128 12l77 142h168zM132 -10q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l125 588h190l-111 -521q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-36 -16 -80 -25t-81 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 564,
    d: "M147 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM148 710h195l-115 -540h299l-36 -170h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 345,
    d: "M15 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM132 -10q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l125 588h190l-111 -521q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-36 -16 -80 -25t-81 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 565,
    d: "M374 588l77 142h168l-132 -174zM148 710h195l-115 -540h299l-36 -170h-494z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 345,
    d: "M325 588l77 142h168l-132 -174zM132 -10q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l125 588h190l-111 -521q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-36 -16 -80 -25t-81 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 565,
    d: "M148 710h195l-115 -540h299l-36 -170h-494zM347 336l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 475,
    d: "M132 -10q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l125 588h190l-111 -521q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-36 -16 -80 -25t-81 -9zM298 262l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 573,
    d: "M-4 353l95 44l67 313h195l-46 -214l68 31l21 -101l-115 -53l-43 -203h299l-36 -170h-494l58 274l-48 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 394,
    d: "M4 353l109 49l70 328h190l-50 -232l65 29l21 -101l-112 -51l-35 -166q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-37 -16 -80.5 -25t-80.5 -9q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l29 138l-62 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 725,
    d: "M498 762l-128 12l77 142h168zM148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 601,
    d: "M386 576l-128 12l77 142h168zM96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 725,
    d: "M207 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 601,
    d: "M139 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54 l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 725,
    d: "M290 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 601,
    d: "M198 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54 l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 601,
    d: "M-101 588l47 87v55h198l-132 -174zM96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 705,
    d: "M336 -209q-82 0 -133 54l105 129q12 -20 39 -20q33 0 43 43l10 47l-135 299l-73 -343h-195l151 710h150l164 -351l74 350h195l-150 -704q-11 -49 -34.5 -88.5t-56 -67.5t-72 -43t-82.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 600,
    d: "M248 -209q-40 0 -74 14t-58 40l105 129q12 -20 38 -20q34 0 44 43l64 299q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190l112 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -26.5t18.5 -37.5t5 -43q0 -19 -2.5 -37.5 t-6.5 -35.5l-71 -334q-11 -49 -34 -89.5t-56 -70t-73 -45.5t-84 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 738,
    d: "M326 793l24 113h296l-24 -113h-296zM303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76 t12 80.5q0 28 -6.5 53t-20 44t-35.5 30t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    d: "M222 607l24 113h296l-24 -113h-296zM232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30 t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5zM484 835q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22zM372 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 738,
    d: "M394 741l-99 9l67 142h138zM579 741l-98 9l66 142h138zM303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5 t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    d: "M308 579l-99 9l67 142h138zM493 579l-98 9l66 142h138zM232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150 q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 977,
    d: "M282 -5q-61 0 -108.5 24.5t-79.5 65t-49 93.5t-17 110q0 81 34 158t91 137t131.5 96t155.5 36q35 0 65.5 -12t57.5 -33l8 40h454l-36 -170h-259l-20 -94h208l-36 -170h-208l-23 -106h268l-36 -170h-463l9 41q-37 -21 -73.5 -33.5t-73.5 -12.5zM321 168q42 0 74.5 23 t54.5 58.5t33 78t11 81.5q0 27 -5.5 51t-17 42t-29 29t-42.5 11q-42 0 -74 -23t-54 -58.5t-33.5 -78t-11.5 -81.5q0 -27 5.5 -51t16.5 -42t29 -29t43 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 947,
    d: "M230 -10q-52 0 -93 16t-70 45t-44.5 69.5t-15.5 88.5q0 69 27 129t72.5 104t107 69t130.5 25q56 0 95 -20.5t69 -65.5q55 46 102 66t100 20q51 0 92 -16t69.5 -45.5t44 -69.5t15.5 -88q0 -38 -8.5 -65t-16.5 -47h-344q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -30 18 -48.5t48 -18.5 q29 0 57 16t42 41l147 -46q-48 -67 -122 -105t-158 -38q-24 0 -44.5 4t-40 13.5t-39 25t-41.5 37.5q-32 -23 -57.5 -38t-48.5 -24.5t-45 -13.5t-46 -4zM266 150q23 0 43 11.5t34.5 31t23 46t8.5 56.5q0 37 -16 59t-45 22q-23 0 -43 -11.5t-34.5 -31t-23 -46t-8.5 -56.5 q0 -37 16 -59t45 -22zM735 319q0 4 0.5 7t0.5 6q0 32 -16 50.5t-45 18.5q-32 0 -58 -22t-37 -60h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 653,
    d: "M469 764l-128 12l77 142h168zM-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5t-21.5 14.5h-103l-32 -152 h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 408,
    d: "M318 576l-128 12l77 142h168zM96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 653,
    d: "M164 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5 t-21.5 14.5h-103l-32 -152h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 408,
    d: "M-23 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 653,
    d: "M252 876l105 42l67 -63l94 63l87 -42l-133 -115h-136zM-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5 t-21.5 14.5h-103l-32 -152h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 408,
    d: "M120 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    d: "M454 776l-128 12l77 142h168zM245 -9q-37 0 -75 6t-74 17t-69 26t-60 34l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5t99.5 55t112.5 19 q37 0 71.5 -7.5t65 -19t56.5 -25t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64q0 -76 -28.5 -127.5t-73.5 -83.5t-100.5 -46t-109.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 485,
    d: "M352 576l-128 12l77 142h168zM191 -10q-66 0 -124.5 22.5t-93.5 65.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61l-95 -114q-41 31 -69 45 t-54 14q-17 0 -27 -8.5t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -46 -18 -84t-51 -65t-79 -42t-102 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    d: "M243 815l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM245 -9q-37 0 -75 6t-74 17t-69 26t-60 34l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5 t99.5 55t112.5 19q37 0 71.5 -7.5t65 -19t56.5 -25t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64q0 -76 -28.5 -127.5t-73.5 -83.5t-100.5 -46t-109.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 485,
    d: "M144 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM191 -10q-66 0 -124.5 22.5t-93.5 65.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61 l-95 -114q-41 31 -69 45t-54 14q-17 0 -27 -8.5t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -46 -18 -84t-51 -65t-79 -42t-102 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    d: "M130 -128q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5q-20 0 -43 -3.5t-34 -5.5l60 89q-66 5 -130 26.5t-111 54.5l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5 q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5t99.5 55t112.5 19q37 0 71.5 -7.5t65 -19t56.5 -25t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64 q0 -70 -24.5 -119.5t-64 -81.5t-89 -48.5t-99.5 -20.5l-23 -26q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 485,
    d: "M64 -128q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5q-20 0 -43 -3.5t-34 -5.5l61 89q-52 7 -97 28.5t-73 56.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5 t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61l-95 -114q-41 31 -69 45t-54 14q-17 0 -27 -8.5t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -44 -16.5 -80t-46.5 -63t-72.5 -43t-93.5 -19l-21 -25q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5 q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    d: "M251 888l105 42l67 -63l94 63l87 -42l-133 -115h-136zM245 -9q-37 0 -75 6t-74 17t-69 26t-60 34l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5 t99.5 55t112.5 19q37 0 71.5 -7.5t65 -19t56.5 -25t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64q0 -76 -28.5 -127.5t-73.5 -83.5t-100.5 -46t-109.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 485,
    d: "M146 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM191 -10q-66 0 -124.5 22.5t-93.5 65.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61 l-95 -114q-41 31 -69 45t-54 14q-17 0 -27 -8.5t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -46 -18 -84t-51 -65t-79 -42t-102 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 600,
    d: "M254 540h-191l36 170h576l-36 -170h-190l-115 -540h-70l-30 -34q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5l48 64q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5 q-20 0 -43 -3.5t-34 -5.5l65 96h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 415,
    d: "M35 -128q8 -7 32 -13.5t50 -6.5q24 0 42 8t18 28q0 14 -12.5 19.5t-34.5 5.5q-20 0 -43 -3.5t-34 -5.5l63 92q-32 9 -51.5 33t-19.5 67q0 11 1 22t4 24l51 241h-61l31 143h61l35 165h190l-35 -165h96l-30 -143h-97l-37 -174q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -29 30 -29 q12 0 30.5 4.5t38.5 12.5v-150q-42 -17 -85.5 -27.5t-83.5 -12.5l-20 -23q5 1 11.5 1.5t13.5 0.5q30 0 53 -14.5t23 -48.5q0 -23 -10.5 -44t-31.5 -37.5t-53.5 -26.5t-76.5 -10q-35 0 -61 6.5t-43 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 600,
    d: "M239 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM254 540h-191l36 170h576l-36 -170h-190l-115 -540h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 415,
    d: "M389 588l77 142h168l-132 -174zM172 -11q-27 0 -50 5.5t-40.5 18.5t-27 33t-9.5 50q0 11 1 22t4 24l51 241h-61l31 143h61l35 165h190l-35 -165h96l-30 -143h-97l-37 -174q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -29 30 -29q12 0 30.5 4.5t38.5 12.5v-150q-44 -17 -90.5 -28.5 t-88.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 620,
    d: "M72 356h152l39 184h-191l36 170h576l-36 -170h-190l-39 -184h152l-19 -88h-152l-56 -268h-195l56 268h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 417,
    d: "M32 336h61l10 47h-61l31 143h61l35 165h190l-35 -165h96l-30 -143h-97l-10 -47h97l-23 -109h-97l-4 -18q-2 -5 -2 -9.5v-8.5q0 -29 30 -29q12 0 30.5 4.5t38.5 12.5v-150q-44 -17 -91 -28.5t-89 -11.5q-27 0 -50 5.5t-40 18.5t-26.5 33t-9.5 50q0 11 1 22t4 24l18 85h-61 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM517 758 q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM418 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49 t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM309 793 l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM211 607l24 113h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM452 835 q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM358 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 712,
    d: "M349 812q0 51 37.5 77.5t98.5 26.5q46 0 72 -17.5t26 -52.5q0 -51 -37.5 -77.5t-97.5 -26.5q-46 0 -72.5 17.5t-26.5 52.5zM473 862q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5zM290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5 t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 618,
    d: "M250 626q0 51 37.5 77.5t98.5 26.5q46 0 72 -17.5t26 -52.5q0 -51 -37.5 -77.5t-97.5 -26.5q-46 0 -72.5 17.5t-26.5 52.5zM374 676q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5zM132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66 l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5t-115.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM379 766 l-99 9l67 142h138zM564 766l-98 9l66 142h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM274 579l-99 9l67 142h138zM459 579l-98 9l66 142h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 712,
    d: "M284 -214q-68 8 -99.5 32.5t-31.5 56.5q0 29 25 60.5t74 60.5q-55 5 -94 25.5t-63.5 52.5t-36 74t-11.5 90q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-14 -65 -40.5 -122.5 t-65 -102.5t-89 -76t-112.5 -43q-40 -23 -62.5 -44t-22.5 -39q0 -14 14.5 -23t46.5 -9l-56 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-40 -23 -62.5 -44t-22.5 -39q0 -14 14.5 -23t46.5 -9l-56 -100q-68 8 -99.5 32.5 t-31.5 56.5q0 29 24 60t71 59q-29 5 -46.5 21.5t-17.5 48.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5t-115.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1002,
    d: "M427 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM69 710h211l35 -487l71 148l-36 339h178l10 -219l103 219h179l-183 -339l11 -148l240 487h213l-414 -710h-161l-39 254l-145 -254h-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 816,
    d: "M300 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63zM34 526h180l38 -353l52 113l-39 240h150l9 -154l75 154h140q-30 -72 -60 -127.5t-71 -112.5l7 -62q27 35 46.5 61.5t35 48t27.5 41.5t23.5 41.5t24 48t28.5 61.5h170q-54 -131 -143 -263t-210 -263h-109l-20 200 l-105 -200h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 627,
    d: "M198 237l-126 473h211l47 -307l181 307h212l-332 -475l-50 -235h-194zM238 801l133 115h136l84 -115l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 543,
    d: "M-56 -93q28 0 48.5 2t36.5 7.5t28.5 14.5t24.5 24l29 34l-69 537h193l12 -365l34 56q36 60 65.5 139t46.5 170h182q-14 -48 -29 -90.5t-38 -89.5t-56.5 -105t-82.5 -138l-80 -129q-36 -58 -71.5 -97.5t-74 -64t-82 -35.5t-95.5 -11zM171 615l133 115h136l84 -115 l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 627,
    d: "M198 237l-126 473h211l47 -307l181 307h212l-332 -475l-50 -235h-194zM216 767l30 140h156l-30 -140h-156zM441 767l30 140h155l-29 -140h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 593,
    d: "M433 762l-128 12l77 142h168zM-6 145l387 395h-288l36 170h514l-31 -145l-368 -395h290l-36 -170h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 472,
    d: "M336 576l-128 12l77 142h168zM-18 112l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 593,
    d: "M-6 145l387 395h-288l36 170h514l-31 -145l-368 -395h290l-36 -170h-535zM308 766l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 472,
    d: "M-18 112l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426zM209 580l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 593,
    d: "M232 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM-6 145l387 395h-288l36 170h514l-31 -145l-368 -395h290l-36 -170h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 472,
    d: "M131 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM-18 112l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 732,
    d: "M296 -5q-74 0 -127 26.5t-87.5 68t-50.5 93t-16 101.5q0 42 9 73t19 54h474q1 7 1.5 13.5t0.5 12.5q0 56 -31 81t-73 25q-19 0 -38.5 -5.5t-37.5 -15.5t-32.5 -24.5t-23.5 -33.5l-192 57q57 87 148.5 140t209.5 53q72 0 124.5 -26t87 -67.5t51 -93.5t16.5 -104 q0 -70 -30.5 -145.5t-86.5 -138.5t-136 -103.5t-179 -40.5zM335 165q51 0 89.5 27t57.5 76h-259q-3 -12 -3 -22q0 -38 33 -59.5t82 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 544,
    d: "M64 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l69 325h-61l31 143h61l12 57q10 49 32 89.5t53 69t68.5 44t79.5 15.5q63 0 135 -30l-62 -144q-14 6 -32 10t-32 4q-41 0 -51 -51l-14 -64h108l-31 -143h-107l-68 -320q-10 -47 -33.5 -86t-55.5 -66.5 t-72 -43t-83 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1286,
    d: "M148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67zM925 874l105 42l67 -63l94 63l87 -42l-133 -115h-136zM687 145 l387 395h-288l36 170h514l-31 -145l-368 -395h290l-36 -170h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1165,
    d: "M148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67zM824 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM675 112 l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1117,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l60 282h191l-111 -520q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-43 0 -70.5 16t-27.5 56q0 5 0.5 10t1.5 10 q-36 -48 -83.5 -70t-96.5 -22zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM776 688l105 42l67 -63l94 63l87 -42l-133 -115h-136zM627 112l279 284h-204l28 130h402 l-24 -112l-279 -284h228l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1052,
    d: "M148 710h195l-115 -540h299l-36 -170h-494zM653 -11q-85 0 -137 44l74 159q2 -2 10 -7t21.5 -10t31 -9t37.5 -4q28 0 46.5 10t32 32.5t24 58t21.5 86.5l77 361h195l-77 -361q-17 -81 -40 -147.5t-62 -113.5t-100 -73t-154 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 854,
    d: "M148 710h195l-115 -540h299l-36 -170h-494zM498 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16zM707 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 635,
    d: "M132 -10q-63 0 -95 27.5t-32 79.5q0 11 1 22t4 23l125 588h190l-111 -521q-3 -12 -3 -22q0 -38 36 -38q11 0 25 4t27 11l-6 -140q-36 -16 -80 -25t-81 -9zM279 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5 t-55.5 -70t-73 -45.5t-84.5 -16zM488 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1213,
    d: "M148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195zM814 -11q-85 0 -137 44l74 159q2 -2 10 -7t21.5 -10t31 -9t37.5 -4q28 0 46.5 10t32 32.5t24 58t21.5 86.5l77 361h195l-77 -361q-17 -81 -40 -147.5t-62 -113.5t-100 -73t-154 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1015,
    d: "M148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195zM659 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16zM868 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 891,
    d: "M96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190zM535 -209q-40 0 -74.5 14t-58.5 40l105 129 q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16zM744 730h190l-34 -160h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 738,
    d: "M294 -214q-68 8 -99.5 32.5t-31.5 56.5q0 30 25.5 61.5t75.5 60.5q-57 7 -101 34t-74 67t-45.5 90t-15.5 104q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -72 -28.5 -140.5t-77 -125t-114.5 -96.5t-141 -54 q-39 -22 -61 -43t-22 -39q0 -14 14.5 -23t46.5 -9zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 595,
    d: "M219 -219q-68 8 -99.5 32.5t-31.5 56.5q0 30 26 62t77 61q-47 6 -81.5 25.5t-57.5 48.5t-34 65.5t-11 76.5q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -54 -19 -107t-54 -96.5t-86 -75t-115 -42.5q-40 -23 -62.5 -44 t-22.5 -39q0 -14 14.5 -23t46.5 -9zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1277,
    d: "M148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67zM678 145l387 395h-288l36 170h514l-31 -145l-368 -395h290 l-36 -170h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1159,
    d: "M148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67zM669 112l279 284h-204l28 130h402l-24 -112l-279 -284h228 l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1117,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l60 282h191l-111 -520q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-43 0 -70.5 16t-27.5 56q0 5 0.5 10t1.5 10 q-36 -48 -83.5 -70t-96.5 -22zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM627 112l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 711,
    d: "M466 60q-44 -34 -86 -49.5t-90 -15.5q-56 0 -104 19.5t-83 56.5t-55 90t-20 121q0 91 36.5 170t97.5 137.5t139 92t162 33.5q45 0 85 -10.5t72 -31t54 -49t33 -64.5l-168 -111q-11 42 -44 67.5t-76 25.5q-38 0 -72 -18.5t-60.5 -50t-42 -74.5t-15.5 -92q0 -63 30 -101 t85 -38q78 0 154 70h-116l29 140h284l-81 -378h-160zM528 762l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 626,
    d: "M159 -223q-79 0 -133.5 26t-90.5 75l122 104q21 -27 55 -45.5t76 -18.5q24 0 47.5 7t43 22.5t34.5 40.5t22 60l7 34q-29 -42 -73.5 -62t-92.5 -20q-40 0 -71.5 15.5t-53 42.5t-32.5 64.5t-11 81.5q0 69 24 129.5t65 105.5t95.5 71t114.5 26q53 0 88.5 -22.5t49.5 -65.5 l17 78h165l-102 -478q-13 -62 -45.5 -112t-80.5 -85t-109 -54.5t-131 -19.5zM277 150q24 0 45.5 13.5t45.5 40.5l20 94q-5 36 -25 57t-46 21q-21 0 -40.5 -12t-35.5 -32t-25.5 -45.5t-9.5 -53.5q0 -37 19 -60t52 -23zM373 576l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 636,
    d: "M507 808q22 -17 22 -49q0 -43 -28 -69l77 -690h-198l-7 139h-170l-65 -139h-199l368 686q-12 15 -12 39q0 38 21 62t58 35l60 105h168zM370 269l-8 220l-103 -220h111zM419 775q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM415 732l-128 12l77 142h168zM214 626q0 51 37.5 77.5t98.5 26.5q46 0 72 -17.5t26 -52.5q0 -51 -37.5 -77.5t-97.5 -26.5 q-46 0 -72.5 17.5t-26.5 52.5zM338 676q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 935,
    d: "M656 762l-128 12l77 142h168zM478 710h505l-37 -170h-259l-20 -94h208l-36 -170h-208l-22 -106h267l-36 -170h-462l30 139h-187l-95 -139h-206zM429 309l39 186l-129 -186h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 902,
    d: "M539 576l-128 12l77 142h168zM130 -10q-66 0 -105 39t-39 101q0 44 20.5 82.5t55.5 66.5t82 44t101 16q60 0 94 -20q2 10 3.5 20.5t1.5 19.5q0 25 -16.5 37t-53.5 12q-42 0 -81.5 -14.5t-84.5 -42.5l-30 118q113 67 242 67q110 0 166 -50q37 23 80.5 36.5t94.5 13.5 q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -83.5q0 -39 -8.5 -66t-16.5 -47h-343q-1 -5 -1.5 -9t-0.5 -10q0 -32 19.5 -46t45.5 -14t54 14t41 39l151 -46q-45 -63 -117 -103t-165 -40q-77 0 -127 28t-74 74q-24 -27 -52 -46.5t-56 -31.5t-55.5 -18t-50.5 -6zM219 126 q23 0 49.5 9.5t46.5 23.5q-1 4 -1 8v8q0 11 1 22t3 25q-14 6 -31.5 10t-31.5 4q-16 0 -31 -5.5t-27 -15t-19 -22t-7 -26.5q0 -18 12 -29.5t36 -11.5zM686 319q0 5 0.5 7t0.5 9q0 30 -15 48t-43 18q-31 0 -55 -22t-36 -60h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 738,
    d: "M520 762l-128 12l77 142h168zM807 710l-116 -128q20 -37 31 -79t11 -87q0 -80 -35 -156t-94 -135t-137 -95t-164 -36q-68 0 -122 26l-18 -20h-209l115 127q-41 74 -41 165q0 81 35 157t94.5 135t138 94.5t164.5 35.5q33 0 62.5 -7t55.5 -19l20 22h209zM341 167 q48 0 84 22.5t60.5 57t36.5 76t12 80.5v6l-218 -240q6 -1 12 -1.5t13 -0.5zM228 302l215 237q-5 1 -11 1.5t-12 0.5q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5v-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    d: "M42 80q-18 28 -26.5 60.5t-8.5 68.5q0 61 23.5 120t68 105t107.5 74t142 28q43 0 77.5 -10t60.5 -28l37 34h101l-90 -82q39 -56 39 -133q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28q-90 0 -144 42l-41 -38h-99zM266 150q22 0 42 11t35 30t24 45.5t9 57.5v6.5t-1 6.5 l-149 -142q15 -15 40 -15zM205 227l144 137q-15 12 -35 12q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5v-5zM411 576l-128 12l77 142h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM432 918h137l7 -142l-100 -14zM246 918h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM354 730h137l7 -142l-100 -14zM168 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 636,
    d: "M320 710h179l79 -710h-198l-7 139h-170l-65 -139h-199zM370 269l-8 220l-103 -220h111zM266 754q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 646,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l16 74h191l-67 -312q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-45 0 -71 17t-26 60q0 10 1 15q-36 -48 -83.5 -70t-96.5 -22z M279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM173 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49 q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM408 918h137l7 -142l-100 -14zM222 918h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM378 730h137l7 -142l-100 -14zM192 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM236 754q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM212 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM277 918h137l7 -142l-100 -14zM91 918h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM232 730h137l7 -142l-100 -14zM46 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM99 754q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM54 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5zM511 918h137l7 -142l-100 -14zM325 918h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22zM387 730h137l7 -142l-100 -14zM201 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5zM314 754q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22zM208 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 653,
    d: "M-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5t-21.5 14.5h-103l-32 -152h108zM423 918h137l7 -142 l-100 -14zM237 918h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 408,
    d: "M96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190zM266 730h137l7 -142l-100 -14zM80 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 653,
    d: "M-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5t-21.5 14.5h-103l-32 -152h108zM261 754q7 36 25 65.5 t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 408,
    d: "M96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190zM116 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM474 918h137 l7 -142l-100 -14zM288 918h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM374 730h137l7 -142l-100 -14zM188 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM301 754 q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM198 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    d: "M139 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM245 -9q-37 0 -75 6t-74 17t-69 26t-60 34l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5 t99.5 55t112.5 19q37 0 71.5 -7.5t65 -19t56.5 -25t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64q0 -76 -28.5 -127.5t-73.5 -83.5t-100.5 -46t-109.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 485,
    d: "M72 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM191 -10q-66 0 -124.5 22.5t-93.5 65.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61 l-95 -114q-41 31 -69 45t-54 14q-17 0 -27 -8.5t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -46 -18 -84t-51 -65t-79 -42t-102 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 600,
    d: "M131 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM254 540h-191l36 170h576l-36 -170h-190l-115 -540h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 415,
    d: "M74 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82zM172 -11q-27 0 -50 5.5t-40.5 18.5t-27 33t-9.5 50q0 11 1 22t4 24l51 241h-61l31 143h61l35 165h190l-35 -165h96l-30 -143h-97l-37 -174q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -29 30 -29q12 0 30.5 4.5t38.5 12.5v-150 q-44 -17 -90.5 -28.5t-88.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 286,
    d: "M-70 -209q-40 0 -74.5 14t-58.5 40l105 129q12 -20 38 -20q33 0 43 43l112 529h191l-109 -514q-11 -49 -34 -89.5t-55.5 -70t-73 -45.5t-84.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 591,
    d: "M227 -10q-58 0 -100.5 16t-70 44t-41 65.5t-13.5 81.5q0 30 6.5 63t17.5 61h345q1 4 1 8v8q0 33 -19.5 48t-44.5 15q-28 0 -55.5 -14t-40.5 -39l-151 46q45 63 116.5 103t165.5 40q57 0 99.5 -17.5t70.5 -47t42 -68.5t14 -83q0 -62 -23.5 -121t-67.5 -105.5t-107.5 -75 t-143.5 -28.5zM258 125q32 0 56 22t37 60h-149q-1 -5 -1 -15q0 -32 14.5 -49.5t42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 506,
    d: "M215 588l47 87v55h198l-132 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 388,
    d: "M18 615l133 115h136l84 -115l-105 -42l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 388,
    d: "M18 688l105 42l67 -63l94 63l87 -42l-133 -115h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 420,
    d: "M74 720h296l-24 -113h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 356,
    d: "M164 649q22 0 43 23t32 58h98q-8 -36 -25.5 -65.5t-42.5 -51t-56.5 -33.5t-65.5 -12q-60 0 -93.5 33t-33.5 88q0 18 5 41h98q-3 -12 -3 -23q0 -25 12 -41.5t32 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 265,
    d: "M32 580l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 263,
    d: "M15 626q0 51 37.5 77.5t98.5 26.5q46 0 72 -17.5t26 -52.5q0 -51 -37.5 -77.5t-97.5 -26.5q-46 0 -72.5 17.5t-26.5 52.5zM139 676q-19 0 -32 -10.5t-13 -27.5q0 -28 31 -28q18 0 32 11t14 28q0 12 -9 19.5t-23 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 323,
    d: "M177 -214q-68 8 -99.5 32.5t-31.5 56.5q0 38 41 78t119 72l51 -24q-40 -23 -62.5 -44t-22.5 -39q0 -14 14.5 -23t46.5 -9l-56 -100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 446,
    d: "M272 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 384,
    d: "M96 579l-99 9l67 142h138zM281 579l-98 9l66 142h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 384,
    d: "M213 730h137l7 -142l-100 -14zM27 730h138l6 -142l-100 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 356,
    d: "M20 568q7 36 25 65.5t43 51t56 33.5t66 12q62 0 94 -35.5t32 -89.5q0 -20 -4 -37h-98q3 18 3 32q0 49 -45 49q-24 0 -45 -16.5t-30 -64.5h-97v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 651,
    d: "M-13 150l237 560h158l236 -560v-150h-631v150zM436 170l-133 327l-127 -327h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 832,
    d: "M36 129h149q-65 38 -102 101.5t-37 144.5q0 67 27 128.5t74.5 108.5t112.5 75t142 28q76 0 141.5 -28t113 -75t74.5 -108.5t27 -128.5q0 -81 -37 -144.5t-102 -101.5h149v-129h-329v129q30 13 53.5 38.5t40 58.5t25.5 71.5t9 77.5q0 31 -11.5 61t-32.5 54t-51.5 38.5 t-69.5 14.5t-69.5 -14.5t-51.5 -38.5t-32.5 -54t-11.5 -61q0 -39 9 -77.5t25.5 -71.5t40 -58.5t53.5 -38.5v-129h-329v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 632,
    d: "M95 526h190l-64 -303q-2 -8 -3 -15t-1 -13q0 -45 42 -45q14 0 36 10t51 44l68 322h190l-67 -316q-3 -12 -3 -21q0 -28 38 -29l-34 -160q-30 -5 -52.5 -7.5t-39.5 -2.5q-96 0 -96 73v19q-6 -11 -20.5 -26.5t-34 -30t-41 -25t-41.5 -10.5q-46 0 -46 36l-39 -239h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 739,
    d: "M531 -10q-76 0 -117 39t-41 113v220h-70v-362h-189v362h-70v160h599v-160h-80v-153q0 -60 49 -60q12 0 26 4t26 11l24 -140q-34 -16 -76.5 -25t-80.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 693,
    d: "M148 710h262q70 0 122 -21.5t86.5 -59t51 -88t16.5 -108.5q0 -94 -32.5 -173.5t-90 -137t-135.5 -90t-169 -32.5h-262zM295 170q42 0 77 19t60 51.5t39 75t14 89.5q0 61 -28.5 98t-82.5 37h-67l-79 -370h67zM143 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 645,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23 128.5t62 106.5t90.5 72.5t108.5 26.5q48 0 82.5 -23t46.5 -65l60 282h191l-111 -520q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -81 -10q-43 0 -70.5 16t-27.5 56q0 5 0.5 10t1.5 10 q-36 -48 -83.5 -70t-96.5 -22zM279 150q24 0 45 13.5t46 40.5l20 94q-5 35 -24.5 56.5t-46.5 21.5q-21 0 -41 -12t-36 -31.5t-25.5 -45.5t-9.5 -54q0 -38 18.5 -60.5t53.5 -22.5zM139 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 724,
    d: "M148 710h195l-56 -262h212l56 262h195l-151 -710h-195l59 278h-212l-59 -278h-195zM164 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 601,
    d: "M139 730h190l-60 -282q35 43 82 65.5t100 22.5q37 0 61.5 -9.5t38.5 -26t19.5 -37.5t5.5 -43q0 -19 -2.5 -38t-6.5 -36l-73 -346h-190l63 296q3 15 3 27q0 25 -11.5 36t-29.5 11q-8 0 -19.5 -5.5t-24.5 -15t-25.5 -23.5t-22.5 -31l-63 -295h-190zM113 -213l32 150h170 l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 725,
    d: "M367 766l32 150h170l-32 -150h-170zM148 710h152l180 -361l76 361h195l-151 -710h-154l-180 349l-74 -349h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 601,
    d: "M270 580l32 150h170l-32 -150h-170zM96 526h171l-17 -78q35 43 87.5 65.5t117.5 22.5q36 0 59.5 -10t37 -27t18.5 -38.5t5 -43.5q0 -19 -2.5 -37t-5.5 -34l-73 -346h-190l63 296q3 15 3 26q0 25 -11.5 36.5t-27.5 11.5q-20 0 -47.5 -21t-46.5 -54l-63 -295h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 653,
    d: "M-3 0l151 710h312q43 0 77 -17.5t57 -46t35.5 -65.5t12.5 -76q0 -35 -10 -69.5t-28.5 -66.5t-44.5 -59.5t-58 -48.5l85 -261h-220l-69 218h-59l-46 -218h-195zM383 388q8 0 18 7t19 20t15 31t6 39q0 26 -9.5 40.5t-21.5 14.5h-103l-32 -152h108zM138 -213l32 150h170 l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 408,
    d: "M96 526h174l-22 -100q38 53 83.5 81.5t90.5 28.5h15t7 -1l-36 -171q-51 0 -96 -12t-72 -40l-66 -312h-190zM-49 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    d: "M245 -9q-37 0 -75 6t-74 17t-69 26t-60 34l120 170q7 -5 25 -18t44.5 -26t59.5 -23t69 -10q34 0 43 11.5t9 25.5q0 13 -11 22.5t-29 17.5t-41.5 15.5t-48.5 17.5q-66 26 -98.5 63t-32.5 94q0 67 27 119.5t71 88.5t99.5 55t112.5 19q37 0 71.5 -7.5t65 -19t56.5 -25 t46 -25.5l-118 -161q-1 1 -15.5 11.5t-37.5 22.5t-52 21.5t-59 9.5q-22 0 -37.5 -10t-15.5 -32q0 -23 29 -35t77 -29q36 -14 65.5 -29t51 -35t33 -47t11.5 -64q0 -76 -28.5 -127.5t-73.5 -83.5t-100.5 -46t-109.5 -14zM116 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 485,
    d: "M191 -10q-66 0 -124.5 22.5t-93.5 65.5l88 114q40 -33 79.5 -51t74.5 -18q20 0 28 8t8 22q0 11 -12 21t-44 21q-43 14 -73 28t-49.5 29t-28.5 33t-9 41q0 44 19.5 82.5t53.5 67t79 45t96 16.5q56 0 102 -15t89 -61l-95 -114q-41 31 -69 45t-54 14q-17 0 -27 -8.5 t-10 -23.5q0 -13 13.5 -21.5t48.5 -19.5q87 -26 123.5 -57t36.5 -80q0 -46 -18 -84t-51 -65t-79 -42t-102 -15zM50 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 600,
    d: "M254 540h-191l36 170h576l-36 -170h-190l-115 -540h-195zM106 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 415,
    d: "M172 -11q-27 0 -50 5.5t-40.5 18.5t-27 33t-9.5 50q0 11 1 22t4 24l51 241h-61l31 143h61l35 165h190l-35 -165h96l-30 -143h-97l-37 -174q-1 -5 -1.5 -9.5t-0.5 -8.5q0 -29 30 -29q12 0 30.5 4.5t38.5 12.5v-150q-44 -17 -90.5 -28.5t-88.5 -11.5zM42 -213l32 150h170 l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1002,
    d: "M69 710h211l35 -487l71 148l-36 339h178l10 -219l103 219h179l-183 -339l11 -148l240 487h213l-414 -710h-161l-39 254l-145 -254h-161zM501 917h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 816,
    d: "M34 526h180l38 -353l52 113l-39 240h150l9 -154l75 154h140q-30 -72 -60 -127.5t-71 -112.5l7 -62q27 35 46.5 61.5t35 48t27.5 41.5t23.5 41.5t24 48t28.5 61.5h170q-54 -131 -143 -263t-210 -263h-109l-20 200l-105 -200h-156zM360 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1002,
    d: "M646 762l-128 12l77 142h168zM69 710h211l35 -487l71 148l-36 339h178l10 -219l103 219h179l-183 -339l11 -148l240 487h213l-414 -710h-161l-39 254l-145 -254h-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 816,
    d: "M513 576l-128 12l77 142h168zM34 526h180l38 -353l52 113l-39 240h150l9 -154l75 154h140q-30 -72 -60 -127.5t-71 -112.5l7 -62q27 35 46.5 61.5t35 48t27.5 41.5t23.5 41.5t24 48t28.5 61.5h170q-54 -131 -143 -263t-210 -263h-109l-20 200l-105 -200h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1002,
    d: "M407 767l30 140h156l-30 -140h-156zM632 767l30 140h155l-29 -140h-156zM69 710h211l35 -487l71 148l-36 339h178l10 -219l103 219h179l-183 -339l11 -148l240 487h213l-414 -710h-161l-39 254l-145 -254h-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 816,
    d: "M279 580l30 140h156l-30 -140h-156zM504 580l30 140h155l-29 -140h-156zM34 526h180l38 -353l52 113l-39 240h150l9 -154l75 154h140q-30 -72 -60 -127.5t-71 -112.5l7 -62q27 35 46.5 61.5t35 48t27.5 41.5t23.5 41.5t24 48t28.5 61.5h170q-54 -131 -143 -263t-210 -263 h-109l-20 200l-105 -200h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 593,
    d: "M-6 145l387 395h-288l36 170h514l-31 -145l-368 -395h290l-36 -170h-535zM101 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 472,
    d: "M-18 112l279 284h-204l28 130h402l-24 -112l-279 -284h228l-28 -130h-426zM41 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM100 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM109 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 575,
    d: "M148 710h474l-36 -170h-279l-21 -100h238l-34 -158h-238l-24 -112h288l-36 -170h-483zM452 758q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8 q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 566,
    d: "M233 -10q-51 0 -93 16t-71.5 45t-45.5 70t-16 92q0 67 27 126t74 103t110.5 69t135.5 25q96 0 149.5 -40.5t53.5 -112.5q0 -89 -81.5 -134t-241.5 -45h-29q0 -43 14.5 -60.5t49.5 -17.5q64 0 98 54l149 -48q-22 -32 -53.5 -58t-69 -45t-78.5 -29t-82 -10zM320 401 q-29 0 -53.5 -22.5t-40.5 -60.5h7q77 0 107.5 9.5t30.5 34.5q0 17 -14 28t-37 11zM423 572q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5 t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 317,
    d: "M148 710h195l-151 -710h-195zM-32 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 286,
    d: "M96 526h190l-112 -526h-190zM139 730h190l-34 -160h-190zM-49 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 738,
    d: "M303 -6q-66 0 -117.5 25t-86.5 66t-53 95t-18 112q0 81 35 157t94.5 135t138 94.5t164.5 35.5q66 0 117 -25t85.5 -66.5t52.5 -95t18 -111.5q0 -80 -35 -156t-94 -135t-137 -95t-164 -36zM341 167q48 0 84 22.5t60.5 57t36.5 76t12 80.5q0 28 -6.5 53t-20 44t-35.5 30 t-52 11q-47 0 -83 -22t-60 -56t-36.5 -75.5t-12.5 -80.5q0 -28 6.5 -53t20 -44.5t35 -31t51.5 -11.5zM175 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    d: "M232 -10q-57 0 -99.5 17.5t-70.5 47.5t-41.5 70t-13.5 84q0 61 23.5 120t67.5 105t107 74t143 28q57 0 99.5 -17.5t70.5 -47.5t41.5 -69.5t13.5 -84.5q0 -61 -23.5 -120t-68 -105t-107.5 -74t-142 -28zM266 150q22 0 42 11t35 30t23.5 45.5t8.5 57.5q0 38 -16 60t-45 22 q-22 0 -42 -11t-35 -30t-23.5 -45.5t-8.5 -57.5q0 -38 16 -60t45 -22zM112 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 712,
    d: "M290 -6q-65 0 -111.5 18.5t-75.5 51.5t-42.5 77.5t-13.5 96.5q0 51 12 107l78 365h195l-78 -365q-8 -40 -8 -71q0 -47 18.5 -77t62.5 -30q30 0 54 15t43 39.5t31.5 56.5t20.5 67l78 365h195l-78 -365q-16 -74 -48 -138.5t-80 -111.5t-111.5 -74t-141.5 -27zM160 -213 l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 618,
    d: "M132 -10q-60 0 -91.5 31.5t-31.5 92.5q0 28 8 66l74 346h189l-64 -303q-3 -15 -3 -27q0 -46 38 -46q17 0 39 10t51 44l69 322h190l-67 -316q-3 -15 -3 -24q0 -25 27 -26l-34 -160q-50 -10 -82 -10q-43 0 -70.5 16.5t-27.5 56.5q0 5 0.5 9.5t1.5 9.5q-45 -49 -97.5 -70.5 t-115.5 -21.5zM110 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 627,
    d: "M198 237l-126 473h211l47 -307l181 307h212l-332 -475l-50 -235h-194zM307 917h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 543,
    d: "M-56 -93q28 0 48.5 2t36.5 7.5t28.5 14.5t24.5 24l29 34l-69 537h193l12 -365l34 56q36 60 65.5 139t46.5 170h182q-14 -48 -29 -90.5t-38 -89.5t-56.5 -105t-82.5 -138l-80 -129q-36 -58 -71.5 -97.5t-74 -64t-82 -35.5t-95.5 -11zM225 730h168l17 -142l-132 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 627,
    d: "M198 237l-126 473h211l47 -307l181 307h212l-332 -475l-50 -235h-194zM474 758q-22 0 -37 7.5t-27.5 16.5t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17 t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 543,
    d: "M-56 -93q28 0 48.5 2t36.5 7.5t28.5 14.5t24.5 24l29 34l-69 537h193l12 -365l34 56q36 60 65.5 139t46.5 170h182q-14 -48 -29 -90.5t-38 -89.5t-56.5 -105t-82.5 -138l-80 -129q-36 -58 -71.5 -97.5t-74 -64t-82 -35.5t-95.5 -11zM394 572q-22 0 -37 7.5t-27.5 16.5 t-25 16.5t-28.5 7.5t-26.5 -7t-16.5 -16t-8 -16.5t-2 -8.5h-101q3 13 16 39.5t35 52.5t52 46t66 20q24 0 39 -8t27.5 -17.5t24 -17.5t27.5 -8q15 0 26 7.5t18 17t10.5 17.5t3.5 9h100q-2 -9 -15.5 -34.5t-36 -53t-53.5 -49t-68 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 593
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 895
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 609,
    d: "M26 191l36 170h510l-36 -170h-510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 911,
    d: "M26 191l36 170h812l-36 -170h-812z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 292,
    d: "M310 730l-53 -131h52l-34 -160h-198l35 165l68 126h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 279,
    d: "M108 501l53 131h-52l34 160h198l-35 -165l-68 -126h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 298,
    d: "M-19 -151l57 151h-51l39 184h198l-40 -189l-72 -146h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 522,
    d: "M310 730l-53 -131h52l-34 -160h-198l35 165l68 126h130zM540 730l-53 -131h52l-34 -160h-198l35 165l68 126h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 509,
    d: "M338 501l53 131h-52l34 160h198l-35 -165l-68 -126h-130zM108 501l53 131h-52l34 160h198l-35 -165l-68 -126h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 532,
    d: "M-19 -151l57 151h-51l39 184h198l-40 -189l-72 -146h-131zM215 -151l58 151h-52l39 184h198l-40 -189l-72 -146h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 496,
    d: "M67 -130l67 316h-125l36 170h126l89 419h180l-90 -419h125l-36 -170h-125l-67 -316h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 523,
    d: "M82 -130l38 183h-125l36 170h126l24 113h-126l36 170h126l57 269h180l-57 -269h124l-36 -170h-125l-24 -113h125l-36 -170h-125l-39 -183h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 364,
    d: "M308 374q0 -28 -12 -53t-31.5 -44t-45 -30t-52.5 -11q-41 0 -66 27.5t-25 68.5q0 28 12 53t32 44t45.5 30t51.5 11q42 0 66.5 -28t24.5 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 714,
    d: "M-13 0l39 184h154l-39 -184h-154zM217 0l39 184h154l-39 -184h-154zM447 0l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1216,
    d: "M232 404q-33 0 -59.5 10t-45 28t-28.5 42t-10 52q0 37 17.5 70.5t46 59t66 40t76.5 14.5q33 0 59.5 -10t45 -28t28.5 -42t10 -52q0 -38 -17.5 -71t-46 -58.5t-66 -40t-76.5 -14.5zM250 494q10 0 20 7t18.5 19t14 27.5t5.5 32.5q0 21 -8.5 35.5t-22.5 14.5q-10 0 -20 -7 t-18.5 -19t-14 -27.5t-5.5 -32.5q0 -21 8.5 -35.5t22.5 -14.5zM559 -10q-33 0 -59.5 10t-45 28t-28.5 42t-10 52q0 37 17.5 70.5t46 59t66 40t76.5 14.5q33 0 59 -10t45 -28t29 -42t10 -52q0 -38 -17.5 -71t-46 -58.5t-66 -40t-76.5 -14.5zM577 80q10 0 20 7t18 19t13.5 28 t5.5 33q0 20 -8 34.5t-22 14.5q-10 0 -20 -7t-18.5 -19t-14 -27.5t-5.5 -32.5q0 -21 8.5 -35.5t22.5 -14.5zM949 -10q-33 0 -59.5 10t-45.5 28t-29 42t-10 52q0 37 17.5 70.5t46 59t66 40t76.5 14.5q33 0 59.5 -10t45.5 -28t29 -42t10 -52q0 -38 -17.5 -71t-46 -58.5 t-66 -40t-76.5 -14.5zM967 80q10 0 20 7t18 19t13.5 28t5.5 33q0 20 -8 34.5t-22 14.5q-10 0 -20 -7t-18.5 -19t-14 -27.5t-5.5 -32.5q0 -21 8.5 -35.5t22.5 -14.5zM71 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 349,
    d: "M30 298l307 198l-32 -152l-135 -85l100 -77l-32 -152l-227 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 349,
    d: "M300 210l-304 -180l32 152l133 77l-98 85l32 152l223 -198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 240,
    d: "M-224 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 496,
    d: "M263 374q-47 0 -80.5 16.5t-55.5 43.5t-32 60t-10 66q0 45 21 91t58 83.5t87 61.5t107 24q47 0 80.5 -17t55.5 -44t32 -60.5t10 -66.5q0 -44 -21 -90t-58 -83.5t-86.5 -61t-107.5 -23.5zM198 575q0 -17 5 -33.5t15.5 -29.5t27.5 -21t41 -8q33 0 58 13.5t42.5 34t26 44 t8.5 43.5q0 17 -5 34t-15.5 30t-27 21t-39.5 8q-34 0 -59.5 -13.5t-43 -34t-26 -44.5t-8.5 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 417,
    d: "M240 381l17 83h-203l23 107l290 250h74l-53 -250h61l-23 -107h-61l-18 -83h-107zM177 571h107l26 121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 397,
    d: "M285 669q63 0 101 -33t38 -86q0 -38 -17.5 -70t-48 -55.5t-72 -37t-88.5 -13.5q-53 0 -93 18.5t-57 50.5l78 76q16 -19 41.5 -29.5t59.5 -10.5q35 0 60.5 14t25.5 49q0 26 -17.5 36.5t-34.5 10.5q-10 0 -22 -3t-23.5 -9t-22 -14t-16.5 -17h-93q27 69 58.5 137t58.5 138 h247l-23 -109h-170l-26 -51q6 2 19.5 5t36.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 430,
    d: "M455 547q0 -36 -18 -68t-49 -56.5t-71 -38.5t-85 -14q-71 0 -109 42t-38 118q0 63 19 116t53 92t81.5 60.5t104.5 21.5q45 0 81.5 -15t59.5 -44l-78 -77q-14 16 -37.5 24t-52.5 8q-43 0 -72.5 -17t-37.5 -49q18 11 45.5 15t49.5 4q72 0 113 -34.5t41 -87.5zM255 470 q18 0 35 5t30.5 13t21.5 19t8 23q0 20 -20.5 32.5t-51.5 12.5q-19 0 -36 -4.5t-30 -12t-21 -18t-8 -22.5q0 -20 21 -34t51 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 406,
    d: "M327 712h-217l23 109h386l-342 -440h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 425,
    d: "M445 531q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44 q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5zM336 529q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 20.5 -27.5t47.5 -10.5q16 0 31 3.5t27 9.5t19 14.5t7 18.5zM232 682q0 -13 17.5 -20t37.5 -7q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5 t-39.5 7.5q-26 0 -47 -9t-21 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 431,
    d: "M100 642q0 36 18 68.5t49 57t71 38.5t85 14q71 0 109 -42.5t38 -118.5q0 -63 -18.5 -116t-52.5 -91.5t-81.5 -60t-104.5 -21.5q-45 0 -82 15t-60 44l78 77q14 -16 37.5 -24.5t52.5 -8.5q43 0 72.5 17.5t37.5 49.5q-17 -11 -45 -15.5t-51 -4.5q-71 0 -112 34.5t-41 87.5z M300 720q-18 0 -35 -5t-30 -13.5t-21 -19t-8 -22.5q0 -20 20.5 -32.5t51.5 -12.5q18 0 35 4.5t30 12t21 17.5t8 22q0 20 -20.5 34.5t-51.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 496,
    d: "M164 -96q-47 0 -81 16.5t-55.5 43.5t-32 60t-10.5 66q0 45 21 91t58 83.5t87 61.5t108 24q46 0 79.5 -17t55.5 -44t32 -60.5t10 -66.5q0 -44 -21 -90t-57.5 -83.5t-86 -61t-107.5 -23.5zM98 105q0 -17 5 -33.5t16 -29.5t27.5 -21t40.5 -8q33 0 58.5 13.5t43 34t26 44 t8.5 43.5q0 17 -5 34t-16 30t-27.5 21t-39.5 8q-34 0 -59.5 -13.5t-43 -34t-26 -44.5t-8.5 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 359,
    d: "M283 17l-22 -107h-299l23 107h99l47 221q-8 -7 -23.5 -16t-33.5 -17.5t-37 -14t-33 -5.5l23 109q19 0 41 9t41.5 20t32.5 20t13 10h110l-72 -336h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 434,
    d: "M-57 -90q9 43 21 74.5t31.5 56t48.5 43.5t72 36q27 11 52 20.5t45 21t32 25t12 31.5t-16.5 24.5t-42.5 6.5q-35 0 -67.5 -13.5t-55.5 -30.5l-51 80q28 29 84 49.5t129 20.5q71 0 108.5 -28.5t37.5 -85.5q0 -42 -15.5 -72t-38 -50t-49 -32t-48.5 -18q-34 -10 -57.5 -21 t-28.5 -31h193l-23 -107h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 406,
    d: "M101 -96q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-49 89q32 28 82.5 42t100.5 14 q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 417,
    d: "M140 -89l17 83h-203l23 107l290 250h74l-53 -250h61l-23 -107h-61l-18 -83h-107zM77 101h107l26 121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 398,
    d: "M186 199q63 0 101 -33t38 -86q0 -38 -17.5 -70t-48 -55.5t-72 -37t-88.5 -13.5q-53 0 -93 18.5t-57 50.5l78 76q16 -19 41.5 -29.5t59.5 -10.5q35 0 60.5 14t25.5 49q0 26 -17.5 36.5t-34.5 10.5q-10 0 -22 -3t-23.5 -9t-22 -14t-16.5 -17h-93q27 69 58.5 137t58.5 138 h247l-23 -109h-170l-26 -51q6 2 19.5 5t36.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 430,
    d: "M356 81q0 -36 -18 -68t-49 -56.5t-71 -38.5t-85 -14q-71 0 -109 42t-38 118q0 63 19 116t53 92t81.5 60.5t104.5 21.5q45 0 81.5 -15t59.5 -44l-78 -77q-14 16 -37.5 24t-52.5 8q-43 0 -72.5 -17t-37.5 -49q18 11 45.5 15t49.5 4q72 0 113 -34.5t41 -87.5zM156 4 q18 0 35 5t30.5 13t21.5 19t8 23q0 20 -20.5 32.5t-51.5 12.5q-19 0 -36 -4.5t-30 -12t-21 -18t-8 -22.5q0 -20 21 -34t51 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 405,
    d: "M226 242h-216l23 109h386l-342 -440h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 426,
    d: "M346 61q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44 q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5zM237 59q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 20.5 -27.5t47.5 -10.5q16 0 31 3.5t27 9.5t19 14.5t7 18.5zM133 212q0 -13 17.5 -20t37.5 -7q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5 t-39.5 7.5q-26 0 -47 -9t-21 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 430,
    d: "M1 176q0 36 18 68.5t49 57t71 38.5t85 14q72 0 109.5 -42.5t37.5 -118.5q0 -63 -18.5 -116t-52.5 -91.5t-81.5 -60t-104.5 -21.5q-45 0 -82 15t-60 44l78 77q14 -16 37.5 -24.5t52.5 -8.5q43 0 72.5 17.5t37.5 49.5q-17 -11 -45 -15.5t-51 -4.5q-71 0 -112 34.5t-41 87.5 zM201 254q-18 0 -35 -5t-30 -13.5t-21 -19t-8 -22.5q0 -20 20.5 -32.5t51.5 -12.5q18 0 35 4.5t30 12t21 17.5t8 22q0 20 -20 34.5t-52 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 563,
    d: "M117 16q-54 29 -80.5 80.5t-26.5 114.5q0 47 14.5 93t42 86.5t67 72t89.5 50.5l28 132h84l-24 -111q10 1 20 1.5t21 0.5q4 0 8 -0.5t8 -0.5l24 110h84l-27 -125q48 -17 77.5 -50t42.5 -77l-197 -56q-16 39 -55 39q-21 0 -40.5 -10.5t-35 -29.5t-24.5 -45.5t-9 -58.5 q0 -38 16.5 -60t44.5 -22q38 0 71 39l173 -56q-32 -45 -75.5 -78t-98.5 -50l-26 -125h-84l24 111q-5 -1 -8.5 -1h-8.5q-22 0 -40 3l-24 -113h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 580,
    d: "M32 0l16 76h-61l26 120h60l110 514h465l-37 -170h-269l-25 -118h219l-34 -158h-219l-15 -68h99l-25 -120h-99l-16 -76h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 555,
    d: "M70 462h63q-1 8 -1.5 16.5t-0.5 16.5q0 46 22 86.5t58 70t83.5 46.5t98.5 17q64 0 116.5 -27.5t83.5 -77.5l-120 -117q-18 29 -50.5 49t-62.5 20q-29 0 -46.5 -19t-17.5 -51q0 -15 3 -30h139l-25 -120h-99q0 -9 -0.5 -16.5t-1.5 -13.5h95l-26 -120h-124 q-10 -11 -20.5 -22.5t-23.5 -23.5q25 8 43.5 11.5t34.5 3.5q29 0 59 -7.5t60 -7.5q16 0 29.5 3t31.5 10l16 -140q-24 -15 -58 -24.5t-63 -9.5q-22 0 -45 5t-46.5 11.5t-47.5 11.5t-48 5q-27 0 -66.5 -7.5t-78.5 -19.5l-9 134q40 23 73 67h-85l26 120h109q0 5 0.5 8.5 t0.5 8.5v6.5t-1 6.5h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 831,
    d: "M820 433h-75l-36 -170h75l-25 -120h-76l-30 -143h-155l-74 143h-149l-30 -143h-195l30 143h-75l26 120h74l36 170h-74l25 120h75l33 157h153l78 -157h144l34 157h195l-34 -157h76zM301 263h62l-44 86zM532 349l18 84h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1113,
    d: "M25 222h176l-17 110h-136l25 120h92l-40 258h211l18 -258h79l-28 258h179l10 -219l103 219h179l-140 -258h80l128 258h212l-150 -258h97l-25 -120h-142l-64 -110h183l-26 -120h-227l-59 -102h-162l-38 254l-145 -254h-162l-16 102h-221zM704 223l53 109h-61zM371 223 l52 109h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 768,
    d: "M143 464q25 51 64 96.5t89 79.5t109.5 54t126.5 20q98 0 162 -42.5t84 -112.5l-171 -106q-4 26 -15.5 43t-28 27t-35.5 14t-37 4q-46 0 -81.5 -21.5t-59.5 -55.5h166l-61 -100h-148q-6 -23 -6 -43h158l-61 -100h-77q14 -25 37 -39.5t56 -14.5q18 0 38 4.5t39.5 15 t37.5 27t31 40.5l139 -95q-23 -39 -60.5 -70t-82 -52t-92.5 -32t-91 -11q-54 0 -98 18t-77.5 48.5t-55.5 72t-32 88.5h-92l61 100h24q1 20 6 43h-63l61 100h36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 564,
    d: "M547 403h-101q-20 -44 -55.5 -80t-82.5 -62l116 -261h-220l-151 368h153q19 0 40 35h-183l26 120h179q-3 17 -10 27t-15 10h-146l31 150h484l-26 -120h-132q6 -16 10 -33t5 -34h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 346,
    d: "M185 -7q-61 0 -95.5 29t-34.5 81v507q0 28 12 51.5t32.5 41t49 27.5t61.5 10q66 0 106 -36t40 -94q0 -44 -15.5 -99.5t-41 -112t-58.5 -108.5t-68 -88v-27q0 -29 12.5 -45.5t34.5 -16.5q10 0 23.5 3.5t24.5 8.5l22 -111q-22 -9 -52 -15t-53 -6zM245 564q0 67 -34 67 q-17 0 -27.5 -17t-10.5 -44v-206q15 24 28 51t22.5 53.5t15.5 51t6 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1087,
    d: "M269 349l-74 -349h-195l151 710h152l180 -361l76 361h195l-151 -710h-154zM903 333q-38 0 -65.5 12t-45.5 32.5t-27 48t-9 58.5q0 43 16 85t45.5 74t72 52t95.5 20q38 0 65.5 -12t45.5 -32.5t27 -47.5t9 -58q0 -44 -15.5 -85.5t-45 -74t-72 -52.5t-96.5 -20zM890 500 q0 -26 10 -40.5t27 -14.5q29 0 50 29.5t21 73.5q0 26 -10 40.5t-27 14.5q-29 0 -50 -29.5t-21 -73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 825,
    d: "M674 710h182l-65 -309h-120l34 161l-68 -119h-96l-18 119l-34 -161h-120l66 309h182v-131zM331 601q-30 14 -48.5 21t-37.5 7q-11 0 -19.5 -2.5t-8.5 -10.5q0 -6 9 -10t35 -11q56 -14 78.5 -32.5t22.5 -47.5q0 -27 -11 -49t-31.5 -38t-48.5 -24.5t-62 -8.5q-19 0 -40 3 t-41 8t-37.5 11.5t-30.5 14.5l61 86q29 -17 55 -26t49 -9q28 0 28 11q0 5 -10.5 9t-37.5 12q-51 14 -72.5 32t-21.5 45q0 26 12 48.5t32.5 39.5t48 26.5t59.5 9.5q60 0 128 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 887,
    d: "M420 592h-90l-41 -191h-119l40 191h-90l26 120h300zM489 710h182v-131l57 131h182l-65 -309h-120l34 161l-68 -119h-96l-18 119l-34 -161h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 832,
    d: "M36 130h149q-65 38 -102 101t-37 144q0 67 27 128.5t74.5 108.5t112.5 75t142 28q76 0 141.5 -28t113 -75t74.5 -108.5t27 -128.5q0 -81 -37 -144t-102 -101h149v-130h-329v130q30 13 53.5 38t40 58t25.5 71.5t9 77.5q0 31 -11.5 61t-32.5 54t-51.5 38.5t-69.5 14.5 t-69.5 -14.5t-51.5 -38.5t-32.5 -54t-11.5 -61q0 -39 9 -77.5t25.5 -71.5t40 -58t53.5 -38v-130h-329v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 628,
    d: "M312 47q73 0 123.5 20.5t80.5 48.5l36 -43q-38 -35 -97.5 -59t-142.5 -24q-65 0 -118.5 22t-91 59t-58 86t-20.5 103q0 57 21 107t58.5 87.5t90.5 59.5t118 22t118 -23.5t91 -64t59 -95.5t21 -118h-430v-131q26 -25 63 -41t78 -16zM312 479q-41 0 -78 -17.5t-63 -52.5 v-114h284v113q-26 36 -63.5 53.5t-79.5 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 880,
    d: "M588 -6q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-49 89q32 28 82.5 42t100.5 14 q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8zM290 395l-23 -107h-214l23 107h53l47 221q-7 -7 -19.5 -16t-26.5 -17.5t-28.5 -14t-25.5 -5.5l23 109q15 0 32.5 9t32.5 20t25.5 20t10.5 10 h110l-72 -336h52zM46 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 902,
    d: "M89 65l233 221h-289q9 43 20.5 74.5t30.5 56t47 43.5t69 36q26 11 50.5 20.5t43.5 21t30.5 25t11.5 31.5t-15.5 24.5t-41.5 6.5q-34 0 -65 -13.5t-53 -30.5l-50 80q28 29 81.5 49.5t123.5 20.5q69 0 105.5 -28.5t36.5 -85.5q0 -42 -15 -72t-37 -50t-47.5 -32t-46.5 -18 q-32 -10 -55 -21t-28 -31h171l-9 -42l35 33l308 337l67 -75l-245 -235q32 17 72.5 26t79.5 9q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15 t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-46 83l-50 -47l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 889,
    d: "M605 -6q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5 q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12zM628 103q16 0 31 3.5t27 9.5t19 14.5t7 18.5q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 20.5 -27.5t47.5 -10.5zM663 275q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5t-39.5 7.5q-26 0 -47 -9t-21 -24 q0 -13 17.5 -20t37.5 -7zM320 395l-23 -107h-244l23 107h72l47 221q-7 -7 -19.5 -16t-26.5 -17.5t-28.5 -14t-25.5 -5.5l23 109q15 0 32.5 9t32.5 20t25.5 20t10.5 10h110l-72 -336h63zM91 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 903,
    d: "M194 279q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-49 89q32 28 82.5 42t100.5 14 q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8zM617 -6q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44 t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12zM640 103q16 0 31 3.5t27 9.5t19 14.5t7 18.5q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5 q0 -17 20.5 -27.5t47.5 -10.5zM675 275q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5t-39.5 7.5q-26 0 -47 -9t-21 -24q0 -13 17.5 -20t37.5 -7zM103 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 913,
    d: "M626 -6q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5 q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12zM649 103q16 0 31 3.5t27 9.5t19 14.5t7 18.5q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 20.5 -27.5t47.5 -10.5zM684 275q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5t-39.5 7.5q-26 0 -47 -9t-21 -24 q0 -13 17.5 -20t37.5 -7zM279 579q63 0 101 -33t38 -86q0 -38 -17.5 -70t-48 -55.5t-72 -37t-88.5 -13.5q-53 0 -93 18.5t-57 50.5l78 76q16 -19 41.5 -29.5t59.5 -10.5q35 0 60.5 14t25.5 49q0 26 -17.5 36.5t-34.5 10.5q-10 0 -22 -3t-23.5 -9t-22 -14t-16.5 -17h-93 q27 69 58.5 137t58.5 138h247l-23 -109h-170l-26 -51q6 2 19.5 5t36.5 3zM121 65l337 319l308 337l67 -75l-323 -309l-322 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 880,
    d: "M597 -6q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5 q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12zM620 103q16 0 31 3.5t27 9.5t19 14.5t7 18.5q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 20.5 -27.5t47.5 -10.5zM655 275q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5t-39.5 7.5q-26 0 -47 -9t-21 -24 q0 -13 17.5 -20t37.5 -7zM51 65l337 319l308 337l67 -75l-323 -309l-322 -347zM325 622h-217l23 109h386l-342 -440h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 582,
    d: "M258 -10q-53 0 -98 16.5t-78 45t-51.5 68t-18.5 85.5q0 52 23 96t60.5 75.5t86 49t99.5 17.5q68 0 103 -34q0 14 -1 27t-3 24q-8 49 -32 75.5t-64 26.5q-20 0 -45 -7t-43 -20l-103 108q45 35 96.5 54t108.5 19q121 0 189 -87t68 -251q0 -89 -20.5 -160.5t-59 -122 t-93.5 -78t-124 -27.5zM272 129q17 0 33.5 8t29.5 21t21 30.5t8 36.5q0 34 -23 56.5t-57 22.5q-19 0 -35.5 -7t-28.5 -19.5t-19 -29t-7 -35.5q0 -35 23 -59.5t55 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 677,
    d: "M633 150v-150h-631v150l237 560h158zM451 170l-133 327l-127 -327h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 756,
    d: "M463 550h-131v-640h-185v640h-80v160h661v-160h-80v-640h-185v640z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 635,
    d: "M580 570h-294v-4l169 -197l-178 -205v-4h303v-160h-513v125l203 231l-196 229v125h506v-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 548,
    d: "M81 280v150h404v-150h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 624,
    d: "M-64 79l687 642l88 -89l-687 -642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 254,
    d: "M36 238l39 184h154l-39 -184h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 576,
    d: "M13 395h247l73 -268l112 663h164l-152 -790h-244l-77 266h-123v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 760,
    d: "M231 557q32 0 56.5 -6.5t43 -18t33.5 -26.5t27 -31q12 16 26.5 31t33.5 26.5t43.5 18t56.5 6.5q41 0 74 -16.5t56.5 -44.5t36 -65.5t12.5 -79.5q0 -43 -14 -80.5t-38 -65t-57 -43.5t-71 -16q-31 0 -55 6t-42.5 16t-33 23t-26.5 28q-23 -29 -59.5 -51t-102.5 -22 q-34 0 -66.5 16.5t-57.5 44.5t-40.5 65.5t-15.5 79.5q0 43 14 80t38 65t57 44t71 16zM251 286q32 0 49.5 19t32.5 45q-15 27 -32.5 46.5t-49.5 19.5q-21 0 -40.5 -14.5t-19.5 -49.5t19.5 -50.5t40.5 -15.5zM531 286q22 0 40.5 15.5t18.5 50.5t-18.5 49.5t-40.5 14.5 q-33 0 -50 -20.5t-30 -49.5q14 -25 31.5 -42.5t48.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 417,
    d: "M107 551q0 1 -1 21t-2 43.5t-2 43t-1 21.5q0 68 38.5 104t111.5 36q38 0 80.5 -9t77.5 -25l-26 -140q-23 15 -43 15q-46 0 -46 -54q0 -1 0.5 -14.5t1.5 -29.5t1.5 -29.5t0.5 -14.5l23 -411q0 -2 1 -22.5t2 -45t2 -45.5t1 -22q0 -69 -38.5 -104.5t-111.5 -35.5 q-38 0 -80.5 9t-77.5 25l26 140q23 -15 43 -15q46 0 46 54q0 1 -1 17t-1.5 34.5t-1.5 34.5t-1 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 471,
    d: "M423 384q-8 -17 -19.5 -34t-27 -30.5t-34.5 -22t-43 -8.5q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-14 -16l-88 44q8 16 19 32t26 29t33.5 20.5t41.5 7.5q24 0 42 -8t33 -17.5t29 -17.5t31 -8q18 0 28.5 8.5t15.5 19.5zM423 200q-8 -17 -19.5 -34 t-27 -30.5t-34.5 -22t-43 -8.5q-23 0 -40.5 7.5t-32.5 16.5t-29.5 16.5t-31.5 7.5t-26 -7t-14 -16l-88 44q8 16 19 32t26 29t33.5 20.5t41.5 7.5q24 0 42 -8t33 -17.5t29 -17.5t31 -8q18 0 28.5 8.5t15.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 462,
    d: "M63 441h197l61 130l65 -34l-46 -96h46v-120h-102l-43 -90h145v-120h-201l-58 -123l-65 32l43 91h-42v120h98l42 90h-140v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 497,
    d: "M48 1v150h380v-150h-380zM52 492l375 168v-182l-198 -55l198 -47v-182l-375 150v148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 530,
    d: "M89 151h380v-150h-380v150zM90 376l198 47l-198 55v182l375 -168v-148l-375 -150v182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 616,
    d: "M429 729l186 -364l-186 -366h-214l-186 366l186 364h214zM446 353l-125 248l-115 -227l124 -250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 236,
    d: "M37 -213l49 61h-57l23 106h156l-22 -106l-67 -61h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 877,
    d: "M196 -10q-31 0 -64.5 5t-65.5 13t-60.5 19.5t-48.5 25.5l96 129q44 -29 85.5 -44t78.5 -15q25 0 35 7.5t10 21.5t-13.5 21.5t-57.5 21.5q-41 13 -69.5 25.5t-46 27.5t-25.5 33.5t-8 44.5q0 45 20.5 83.5t54 67t75.5 44.5t85 16q10 0 25 -1t32 -4.5t34.5 -10t31.5 -16.5 q-4 8 -5 20t-1 21q0 37 13.5 70.5t42.5 59t75 40t111 14.5q46 0 77 -7.5t49.5 -22t26 -35t7.5 -46.5q0 -19 -3.5 -43t-9.5 -50h97l-30 -143h-97l-37 -174q-2 -6 -2 -9v-5q0 -20 7 -26.5t21 -6.5t32 4.5t38 12.5v-150q-44 -17 -90.5 -28.5t-88.5 -11.5q-27 0 -50 5.5t-40 18 t-26.5 33.5t-9.5 51q0 8 1 20t4 25l51 241h-61l30 143h61q5 24 7.5 43t2.5 33q0 26 -10 37.5t-33 11.5q-40 0 -65 -29.5t-25 -72.5q0 -16 4 -35.5t15 -33.5l-95 -121q-45 26 -75 36.5t-55 10.5q-47 0 -47 -33q0 -8 3.5 -13.5t11.5 -9.5t20.5 -7.5t30.5 -9.5q46 -15 77 -28 t49.5 -28.5t26 -35t7.5 -46.5q0 -44 -17.5 -81.5t-50 -65t-78 -43t-101.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 592,
    d: "M112 568h349q27 0 47.5 -10t34 -27t20.5 -38.5t7 -44.5t-8 -46.5t-23 -44.5t-36.5 -38.5t-49.5 -27.5q40 -12 62.5 -40t22.5 -73q0 -48 -21 -82t-55.5 -55.5t-80.5 -31t-95 -9.5h-295zM316 143q21 0 37 11.5t16 34.5q0 14 -8.5 23t-22.5 9h-130l-17 -78h125zM343 354 q19 0 34 6.5t15 36.5q0 15 -9 20.5t-21 5.5h-111l-15 -69h107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 570,
    d: "M249 -5q-56 0 -99.5 20.5t-73.5 55t-45.5 79t-15.5 91.5q0 59 27 118t75 106t114.5 76.5t144.5 29.5q82 0 136 -33.5t71 -90.5l-149 -93q-3 19 -13 32t-23 20.5t-28 10.5t-29 3q-37 0 -65 -15.5t-47.5 -39.5t-29.5 -53.5t-10 -57.5q0 -22 6 -41.5t18 -34.5t30 -23.5 t42 -8.5q29 0 62 14.5t53 50.5l121 -84q-20 -32 -51.5 -56.5t-68 -41t-76.5 -25.5t-76 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 580,
    d: "M281 568h138l105 -568h-179l-15 102h-159l-57 -102h-181zM324 250l-18 113l-68 -113h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 625,
    d: "M112 568h235q65 0 113 -17.5t79.5 -48.5t47 -72.5t15.5 -89.5q0 -74 -28.5 -136.5t-79 -107.5t-119 -70.5t-149.5 -25.5h-235zM257 148q38 0 69.5 13t53.5 35.5t34 53t12 64.5q0 48 -28.5 77t-82.5 29h-65l-58 -272h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 523,
    d: "M112 568h427l-31 -148h-258l-13 -62h220l-29 -138h-220l-16 -72h266l-32 -148h-435z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 494,
    d: "M112 568h418l-31 -148h-249l-16 -78h203l-29 -138h-204l-43 -204h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 683,
    d: "M303 -5q-65 0 -116 24.5t-86 65.5t-53.5 95.5t-18.5 114.5q0 76 31.5 151t87 135t132.5 97t169 37q88 0 146 -37t81 -108l-181 -121q0 5 -3.5 20.5t-13.5 31.5t-28.5 28.5t-49.5 12.5q-41 0 -73 -22.5t-54.5 -58t-34 -78.5t-11.5 -84q0 -24 4.5 -47t15 -42t28.5 -30.5 t44 -11.5q35 0 67.5 18.5t50.5 41.5h-98l36 170h309q-5 -23 -9.5 -44.5t-9.5 -44.5q-13 -65 -46 -122t-80.5 -99.5t-107.5 -67.5t-128 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 601,
    d: "M372 41q-35 -24 -68 -34.5t-69 -10.5q-48 0 -88 19t-69.5 52t-45.5 77t-16 94q0 69 30 130t79.5 106.5t114 71.5t134.5 26q76 0 130 -33t71 -91l-147 -97q-8 31 -34 50.5t-58 19.5q-29 0 -55.5 -13t-46.5 -36t-32 -54t-12 -68q0 -48 24 -75.5t68 -27.5q48 0 99 37h-89 l26 122h251l-66 -306h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 652,
    d: "M112 568h170l-44 -203h201l44 203h170l-121 -568h-170l46 216h-201l-46 -216h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 281,
    d: "M112 568h170l-121 -568h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 441,
    d: "M77 -9q-78 0 -125 35l65 139q5 -7 30 -15t62 -8q26 0 43.5 7t29.5 23.5t20 42.5t16 64l61 289h170l-61 -289q-14 -65 -33 -118t-53 -91t-87.5 -58.5t-137.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 603,
    d: "M112 568h170l-47 -218l246 218h175l-275 -255l170 -313h-178l-113 218l-63 -50l-36 -168h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 461,
    d: "M112 568h170l-90 -420h230l-32 -148h-399z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 274,
    d: "M15 588l77 142h168l-132 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 740,
    d: "M112 568h186l76 -250l182 250h185l-121 -568h-170l59 275l-140 -189h-90l-60 189l-58 -275h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 655,
    d: "M112 568h133l185 -262l56 262h170l-121 -568h-135l-185 253l-54 -253h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 634,
    d: "M251 -5q-56 0 -100 20t-74 53.5t-46 77.5t-16 91q0 64 29.5 124.5t79.5 107t115.5 74.5t137.5 28q57 0 101 -20t73.5 -54t45 -77.5t15.5 -90.5q0 -63 -29 -123t-78.5 -107t-115 -75.5t-138.5 -28.5zM285 146q37 0 66 16t48 40.5t29 54.5t10 58q0 42 -23 73.5t-72 31.5 q-38 0 -66.5 -15.5t-47.5 -39.5t-29 -54t-10 -58q0 -21 5.5 -40.5t17 -34t29.5 -23.5t43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 544,
    d: "M112 568h263q39 0 70.5 -14.5t53 -38t33 -54t11.5 -62.5q0 -42 -19.5 -83t-53.5 -74t-79.5 -53t-96.5 -20h-97l-36 -169h-170zM315 318q9 0 18.5 2.5t17 10t12.5 20t5 32.5q0 23 -11.5 30t-23.5 7h-83l-22 -102h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 637,
    d: "M398 29q-34 -16 -71.5 -24.5t-76.5 -8.5q-56 0 -100 20t-74 53.5t-46 77t-16 90.5q0 64 29.5 124t79.5 107t115.5 75.5t137.5 28.5q57 0 101 -20.5t73.5 -54t45 -77.5t15.5 -91q0 -63 -29 -122.5t-78 -106.5l75 -100h-159zM285 147q6 0 12 0.5t12 1.5l-75 100h159l19 -26 q25 45 25 92q0 21 -5.5 40t-17 34t-29.5 23.5t-43 8.5q-37 0 -65.5 -15.5t-48 -40t-29.5 -54.5t-10 -58q0 -21 5.5 -40t17 -34t29.5 -23.5t44 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 598,
    d: "M112 568h280q39 0 70.5 -14.5t53 -38t33 -54t11.5 -62.5q0 -56 -34 -106.5t-91 -85.5l94 -207h-193l-79 169h-60l-36 -169h-170zM333 318q17 0 34.5 16t17.5 46q0 20 -11 30t-24 10h-100l-22 -102h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 523,
    d: "M206 -8q-32 0 -65 5t-64.5 13.5t-60.5 20.5t-52 26l105 149q2 -5 16.5 -15t38 -20t54 -17.5t64.5 -7.5q23 0 31.5 5t8.5 13q0 9 -9.5 15.5t-25.5 12t-36 11t-42 13.5q-59 22 -87 53t-28 79q0 54 23 95.5t60.5 70.5t85 44t96.5 15q32 0 61.5 -6t56 -15t49 -20t40.5 -20 l-102 -141q-2 2 -15 10.5t-33 17.5t-44.5 16t-50.5 7q-18 0 -29.5 -4.5t-11.5 -15.5q0 -16 25.5 -24.5l67.5 -22.5q32 -11 58 -23.5t44.5 -29t28.5 -39t10 -52.5q0 -62 -24.5 -104t-63.5 -67.5t-86.5 -36.5t-93.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 545,
    d: "M213 420h-175l31 148h520l-32 -148h-173l-90 -420h-171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 630,
    d: "M250 -5q-59 0 -100 15t-67.5 42t-38.5 63.5t-12 79.5q0 38 9 80l62 293h170l-62 -293q-2 -12 -3.5 -22.5t-1.5 -21.5q0 -37 17.5 -61t58.5 -24q27 0 48.5 10.5t37 28.5t26 41.5t15.5 48.5l62 293h170l-62 -293q-13 -60 -40 -111t-68.5 -88.5t-96.5 -59t-124 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 581,
    d: "M48 568h180l48 -327l184 327h179l-344 -568h-141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1101,
    d: "M84 710h221l19 -415l205 415h212l28 -414l195 415h222l-359 -710h-202l-58 390l-224 -391h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 915,
    d: "M46 568h184l62 -364l50 89l-40 275h156l17 -171l89 171h157l-159 -275l14 -89l215 364h186l-360 -568h-141l-45 192l-126 -192h-141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 577,
    d: "M194 280l-142 288h184l73 -169l144 169h184l-264 -288l137 -280h-184l-67 161l-136 -161h-185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 567,
    d: "M170 186l-125 382h184l57 -237l159 237h185l-290 -383l-40 -185h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 546,
    d: "M-8 126l344 294h-269l32 148h466l-27 -126l-328 -294h271l-32 -148h-484z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 627,
    d: "M193 -10q-43 0 -77.5 15.5t-58.5 43.5t-37 67.5t-13 86.5q0 67 23 127.5t62 106.5t90.5 72.5t107.5 26.5q49 0 83.5 -23t46.5 -65l15 70h190l-110 -518h-189l15 69q-29 -40 -64.5 -59.5t-83.5 -19.5zM278 150q25 0 46.5 13.5t44.5 40.5l20 94q-5 36 -25 57t-46 21 q-21 0 -40.5 -12t-35.5 -31.5t-25.5 -45.5t-9.5 -53q0 -38 19 -61t52 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 565,
    d: "M130 -10q-66 0 -105 39t-39 100q0 45 20 83.5t55 66.5t82 44t102 16q56 0 93 -20l3 16q1 6 1.5 11.5t0.5 10.5q0 26 -16 38.5t-53 12.5q-42 0 -81.5 -14.5t-85.5 -42.5l-29 118q115 67 242 67q104 0 158.5 -41t54.5 -122q0 -30 -7 -61l-66 -312h-183l13 65 q-63 -75 -160 -75zM216 126q14 0 30 5.5t30 14.5q12 8 21 17.5t11 19.5l8 39q-13 6 -29.5 10t-30.5 4q-35 0 -60 -20t-25 -49q0 -18 12 -29.5t33 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 968,
    d: "M233 -10q-57 0 -99.5 17.5t-70.5 48t-42 70.5t-14 85q0 60 23.5 118.5t68 104.5t109.5 74t148 28q22 0 39.5 -2.5t32.5 -7t28.5 -11.5t27.5 -16q-1 5 -1 15.5v15.5q0 98 62 149t180 51q49 0 80.5 -9.5t49.5 -25.5t25 -37t7 -45q0 -21 -3.5 -43.5t-8.5 -43.5h96l-30 -143 h-97l-37 -174q-2 -5 -2 -9.5v-8.5q0 -29 30 -29q12 0 30.5 4.5t38.5 12.5v-150q-44 -17 -90.5 -28.5t-88.5 -11.5q-27 0 -50 5.5t-40.5 18.5t-27 33t-9.5 50q0 11 1 22t4 24l51 241h-61l31 143h61q9 46 9 73q0 28 -10.5 40t-33.5 12q-31 0 -49.5 -13t-28.5 -33.5t-13 -46 t-3 -51.5q0 -31 3 -64t7 -50l-197 -56q-16 39 -55 39q-20 0 -39.5 -10.5t-35 -29.5t-25 -45.5t-9.5 -58.5q0 -38 16.5 -60t44.5 -22q38 0 71 39l173 -56q-45 -63 -114.5 -103t-162.5 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 627,
    d: "M193 -10q-44 0 -78.5 15.5t-58.5 43.5t-36.5 67t-12.5 86q0 68 23.5 128.5t62.5 106.5t90 72.5t107 26.5q49 0 84 -23t46 -65l60 282h190l-155 -730h-189l15 69q-29 -40 -64 -59.5t-84 -19.5zM278 150q26 0 46.5 13.5t45.5 40.5l20 94q-6 36 -25.5 57t-46.5 21 q-21 0 -40.5 -12t-35.5 -31.5t-25.5 -45.5t-9.5 -53q0 -38 19 -61t52 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 591,
    d: "M538 254q0 -57 -26 -105.5t-68.5 -83.5t-98.5 -55t-116 -20q-44 0 -83 13.5t-67.5 39t-45 62t-16.5 81.5q0 37 11 67t28.5 53.5t37.5 41.5t38 31q-17 14 -26.5 40.5t-9.5 54.5q0 56 28 100t71 74t92.5 46t93.5 16q35 0 70.5 -11.5t64 -33.5t46.5 -55t18 -76 q0 -24 -7.5 -48t-20.5 -44.5t-29 -36.5t-33 -26q17 -18 32.5 -50t15.5 -75zM345 248q0 53 -50 53q-35 0 -57.5 -24t-22.5 -59q0 -23 13.5 -39t36.5 -16q34 0 57 25t23 60zM289 482q0 -20 10.5 -30t24.5 -10q20 0 39.5 16t19.5 46q0 17 -9.5 28t-27.5 11q-24 0 -40.5 -18 t-16.5 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 557,
    d: "M190 -9q-75 0 -128 29t-74 83l129 120q20 -31 49.5 -48.5t59.5 -17.5q39 0 62.5 26t23.5 67q0 24 -11.5 39t-33.5 15q-18 0 -34.5 -9.5t-27.5 -25.5h-162q45 111 86.5 221t87.5 221h339l-37 -173h-202l-24 -77q3 2 13 3.5t24 1.5q42 0 75.5 -13.5t57.5 -37.5t36.5 -58 t12.5 -75q0 -63 -25 -116t-68.5 -92t-102.5 -61t-126 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 575,
    d: "M200 1l29 136h-237l36 170l383 404h130l-86 -404h84l-36 -170h-84l-29 -136h-190zM287 307l26 120l-98 -120h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 286,
    d: "M94 517h190l-155 -730h-190zM139 730h189l-34 -160h-189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 286,
    d: "M139 730h190l-155 -730h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 593,
    d: "M68 424q0 59 25.5 112t69 93t100 63.5t118.5 23.5q97 0 146 -64.5t49 -179.5q0 -102 -27 -190t-75.5 -153t-116 -102t-149.5 -37q-121 0 -196 96l131 122q40 -54 103 -54q43 0 74 29.5t45 83.5q-22 -17 -46.5 -25.5t-56.5 -8.5q-44 0 -80 14.5t-61.5 40t-39 60.5 t-13.5 76zM347 557q-17 0 -33.5 -9t-30 -24t-22 -34.5t-8.5 -40.5q0 -29 15.5 -48t41.5 -19q18 0 34.5 8t29.5 22t21 32.5t8 39.5q0 30 -15.5 51.5t-40.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 534,
    d: "M35 170h136l77 362q-11 -12 -32.5 -26.5t-47 -28t-51.5 -22.5t-45 -9l37 174q25 0 56 14.5t57.5 31.5t44.5 32t19 17h194l-115 -545h120l-36 -170h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 626,
    d: "M341 78q-29 -43 -73.5 -65.5t-98.5 -22.5q-38 0 -68 15.5t-51 43.5t-32 66.5t-11 84.5q0 70 24.5 131.5t65.5 107t94.5 71.5t112.5 26q57 0 90 -24t50 -67l17 81h165l-157 -740h-190zM278 150q43 0 90 54l20 94q-6 35 -25.5 56.5t-45.5 21.5q-21 0 -41.5 -12t-36 -31.5 t-25 -45t-9.5 -53.5q0 -38 19 -61t54 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 585,
    d: "M337 538h-249l37 173h548l-480 -710h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 593,
    d: "M234 -10q-97 0 -146 64.5t-49 179.5q0 102 27 190t75.5 153t116.5 102t150 37q122 0 195 -96l-131 -122q-40 54 -102 54q-44 0 -75 -29.5t-45 -83.5q43 34 103 34q44 0 80 -14.5t61.5 -40t39 -60.5t13.5 -76q0 -59 -25.5 -112t-69 -93t-100 -63.5t-118.5 -23.5zM268 149 q16 0 33 9t30.5 24t22 34.5t8.5 40.5q0 29 -15.5 48t-41.5 19q-18 0 -34.5 -8t-29.5 -22t-21 -32.5t-8 -39.5q0 -30 15.5 -51.5t40.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 425,
    d: "M114 356h-76l36 170h76l35 165h196l-36 -165h114l-36 -170h-114l-75 -356h-195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 564,
    d: "M185 -9q-75 0 -122.5 28t-69.5 88l125 132q2 -3 6 -14.5t14 -25t28.5 -24t49.5 -10.5q18 0 34.5 4t29 12.5t20.5 20.5t8 28q0 35 -39 48t-119 13h-31l33 157h31q33 0 63.5 4t54 12.5t38 22.5t14.5 34q0 12 -4.5 18.5t-10.5 9.5t-12 3.5t-10 0.5q-26 0 -47.5 -7.5 t-38.5 -18t-28.5 -21.5t-17.5 -18l-90 141q24 22 55.5 39t66 28t70 17t67.5 6q47 0 85.5 -12.5t66 -34.5t42.5 -52.5t15 -66.5q0 -33 -12.5 -62t-33.5 -51.5t-49.5 -38t-60.5 -21.5q48 -8 73.5 -49t25.5 -98q0 -65 -30.5 -110.5t-77 -75t-103.5 -43t-109 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 614,
    d: "M-25 0q15 69 30.5 120.5t41 91.5t64.5 70.5t100 57.5q37 16 69 32.5t56 35t38 42t14 54.5q0 26 -13.5 36t-30.5 10q-35 0 -76.5 -22t-74.5 -50l-90 127q25 22 58.5 42.5t72.5 36.5t83 25t90 9q99 0 151 -46t52 -131q0 -50 -10 -87t-31.5 -67t-55.5 -56t-83 -54 q-21 -12 -43 -24t-41 -25t-33 -27.5t-17 -30.5h240l-36 -170h-525v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 600,
    d: "M144 -10q-135 0 -135 123q0 15 2 31.5t6 35.5l74 346h190l-64 -303q-3 -15 -3 -27q0 -46 41 -46q14 0 35.5 10t51.5 44l68 322h190l-112 -526h-182l15 70q-35 -45 -82 -62.5t-95 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 868,
    d: "M44 526h195l21 -302l130 302h179v-302l149 302h195l-279 -526h-219v229l-108 -229h-207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 523,
    d: "M-17 -213q33 54 63.5 106.5t60.5 106.5l-67 526h205v-365l147 365h177l-364 -739h-222v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 689,
    d: "M278 -10q-63 0 -108.5 26t-74.5 67.5t-43 93.5t-14 104q0 49 14 100t39.5 98.5t61.5 89.5t79.5 73.5t94 49.5t104.5 18q63 0 108.5 -26.5t75 -69t43 -95t13.5 -103.5q0 -49 -14 -99.5t-39.5 -97.5t-61.5 -89t-79.5 -73t-94 -49t-104.5 -18zM315 163q39 0 68.5 25.5 t49.5 63t30 80t10 76.5q0 24 -4 47.5t-13.5 41.5t-24.5 29t-36 11q-40 0 -69.5 -28t-49.5 -68.5t-30 -85.5t-10 -79q0 -23 4 -43.5t13.5 -36t24.5 -24.5t37 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 265,
    d: "M2 -213l32 150h170l-32 -150h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 496,
    d: "M245 284q-47 0 -81 16.5t-55.5 43.5t-32 60t-10.5 66q0 45 21 91t58 83.5t87 61.5t108 24q46 0 79.5 -17t55.5 -44t32 -60.5t10 -66.5q0 -44 -21 -90t-57.5 -83.5t-86 -61t-107.5 -23.5zM179 485q0 -17 5 -33.5t16 -29.5t27.5 -21t40.5 -8q33 0 58.5 13.5t43 34t26 44 t8.5 43.5q0 17 -5 34t-15.5 30t-27.5 21t-40 8q-34 0 -59.5 -13.5t-43 -34t-26 -44.5t-8.5 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 313,
    d: "M311 395l-23 -107h-244l23 107h72l47 221q-7 -7 -19.5 -16t-26.5 -17.5t-28.5 -14t-25.5 -5.5l23 109q15 0 32.5 9t32.5 20t25.5 20t10.5 10h110l-72 -336h63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 428,
    d: "M23 286q9 43 21.5 74.5t32 56t48.5 43.5t71 36q27 11 52.5 20.5t45 21t31.5 25t12 31.5t-16.5 24.5t-42.5 6.5q-35 0 -67.5 -13.5t-55.5 -30.5l-51 80q29 29 84.5 49.5t127.5 20.5t109.5 -28.5t37.5 -85.5q0 -42 -15.5 -72t-38 -50t-49 -32t-48.5 -18q-34 -10 -57.5 -21 t-28.5 -31h174l-23 -107h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 407,
    d: "M181 279q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-49 89q32 28 82.5 42t100.5 14 q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 417,
    d: "M221 291l17 83h-203l23 107l290 250h74l-53 -250h61l-23 -107h-61l-18 -83h-107zM158 481h107l26 121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 398,
    d: "M267 579q63 0 101 -33t38 -86q0 -38 -17.5 -70t-48 -55.5t-72 -37t-88.5 -13.5q-53 0 -93 18.5t-57 50.5l78 76q16 -19 41.5 -29.5t59.5 -10.5q35 0 60.5 14t25.5 49q0 26 -17.5 36.5t-34.5 10.5q-10 0 -22 -3t-23.5 -9t-22 -14t-16.5 -17h-93q27 69 58.5 137t58.5 138 h247l-23 -109h-170l-26 -51q6 2 19.5 5t36.5 3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 430,
    d: "M436 457q0 -36 -18 -68t-49 -56.5t-71 -38.5t-85 -14q-71 0 -109 42t-38 118q0 63 19 116t53 92t81.5 60.5t104.5 21.5q45 0 81.5 -15t59.5 -44l-78 -77q-14 16 -37.5 24t-52.5 8q-43 0 -72.5 -17t-37.5 -49q18 11 45.5 15t49.5 4q72 0 113 -34.5t41 -87.5zM236 380 q18 0 35 5t30.5 13t21.5 19t8 23q0 20 -20.5 32.5t-51.5 12.5q-19 0 -36 -4.5t-30 -12t-21 -18t-8 -22.5q0 -20 20.5 -34t51.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 403,
    d: "M307 622h-217l23 109h386l-342 -440h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 427,
    d: "M427 441q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44 q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5zM318 439q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 21 -27.5t47 -10.5q16 0 31 3.5t27 9.5t19 14.5t7 18.5zM214 592q0 -13 17.5 -20t37.5 -7q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5 t-39.5 7.5q-26 0 -47 -9t-21 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 430,
    d: "M81 552q0 36 18 68.5t48.5 57t71 38.5t85.5 14q71 0 109 -42.5t38 -118.5q0 -63 -18.5 -116t-52.5 -91.5t-81.5 -60t-104.5 -21.5q-45 0 -82 15t-60 44l78 77q14 -16 37.5 -24.5t52.5 -8.5q43 0 72.5 17.5t37.5 49.5q-17 -11 -45 -15.5t-51 -4.5q-72 0 -112.5 34.5 t-40.5 87.5zM281 630q-18 0 -35 -5t-30 -13.5t-21 -19t-8 -22.5q0 -20 20.5 -32.5t51.5 -12.5q18 0 35 4.5t30 12t21 17.5t8 22q0 20 -20.5 34.5t-51.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 495,
    d: "M183 -6q-47 0 -81 16.5t-55.5 43.5t-32 60t-10.5 66q0 45 21 91t58 83.5t87 61.5t108 24q46 0 79.5 -17t55.5 -44t32 -60.5t10 -66.5q0 -44 -21 -90t-57.5 -83.5t-86 -61t-107.5 -23.5zM206 103q33 0 58.5 13.5t43 34t26 44t8.5 43.5q0 17 -5 34t-16 30t-27.5 21t-39.5 8 q-34 0 -59.5 -13.5t-43 -34t-26 -44.5t-8.5 -44q0 -17 5 -33.5t15.5 -29.5t27.5 -21t41 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 360,
    d: "M5 107h99l47 221q-8 -7 -23.5 -16t-33.5 -17.5t-37 -14t-33 -5.5l23 109q19 0 41 9t41.5 20t32.5 20t13 10h110l-72 -336h90l-22 -107h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 433,
    d: "M-38 0q9 43 21 74.5t31.5 56t48.5 43.5t72 36q27 11 52 20.5t45 21t32 25t12 31.5t-16.5 24.5t-42.5 6.5q-35 0 -67.5 -13.5t-55.5 -30.5l-51 80q28 29 84 49.5t129 20.5q71 0 108.5 -28.5t37.5 -85.5q0 -42 -15.5 -72t-38 -50t-49 -32t-48.5 -18q-34 -10 -57.5 -21 t-28.5 -31h193l-23 -107h-373v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 407,
    d: "M121 -6q-60 0 -99 17t-50 54l74 84q1 -2 6.5 -9t17 -15t29 -14.5t43.5 -6.5q36 0 63.5 8.5t27.5 30.5q0 21 -34.5 29t-97.5 8h-24l21 99h23q58 0 97 9.5t39 33.5q0 7 -6 11.5t-14.5 7t-18 3.5t-16.5 1q-37 0 -63 -12t-51 -32l-49 89q32 28 82.5 42t100.5 14 q69 0 111.5 -30t42.5 -75q0 -42 -32 -69.5t-83 -35.5q40 -6 60.5 -32.5t20.5 -61.5q0 -40 -20 -68t-51.5 -46t-71 -26t-78.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 418,
    d: "M177 84h-203l23 107l290 250h74l-53 -250h61l-23 -107h-61l-18 -83h-107zM204 191l26 121l-133 -121h107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 397,
    d: "M117 -6q-53 0 -93 18.5t-57 50.5l78 76q16 -19 41.5 -29.5t59.5 -10.5q35 0 60.5 14t25.5 49q0 26 -17.5 36.5t-34.5 10.5q-21 0 -46 -12t-38 -31h-93q27 69 58.5 137t58.5 138h247l-23 -109h-170l-26 -51q6 2 19.5 5t36.5 3q63 0 101 -33t38 -86q0 -38 -17.5 -70 t-48 -55.5t-72 -37t-88.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 430,
    d: "M152 -6q-71 0 -109 42t-38 118q0 63 19 116t53 92t81.5 60.5t104.5 21.5q45 0 81.5 -15t59.5 -44l-78 -77q-14 16 -37.5 24t-52.5 8q-43 0 -72.5 -17t-37.5 -49q18 11 45.5 15t49.5 4q72 0 113 -34.5t41 -87.5q0 -36 -18 -68t-49 -56.5t-71 -38.5t-85 -14zM175 94 q18 0 35 5t30.5 13t21.5 19t8 23q0 20 -20.5 32.5t-51.5 12.5q-19 0 -36 -4.5t-30 -12t-21 -18t-8 -22.5q0 -20 21 -34t51 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 405,
    d: "M245 332h-216l23 109h386l-342 -440h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 426,
    d: "M149 -6q-34 0 -63 9t-50.5 25.5t-33.5 38.5t-12 49q0 24 7.5 42t21 32t31.5 24.5t38 20.5q-18 9 -30.5 25t-12.5 41q0 30 18.5 55.5t47.5 44t63.5 29t67.5 10.5q27 0 53.5 -8t47.5 -22.5t33.5 -34.5t12.5 -44q0 -35 -23 -58.5t-55 -37.5q24 -14 39 -34.5t15 -49.5 q0 -33 -18.5 -61.5t-48.5 -50t-69 -33.5t-80 -12zM172 103q16 0 31 3.5t27 9.5t19 14.5t7 18.5q0 17 -20 27t-48 10q-34 0 -59 -12.5t-25 -32.5q0 -17 20.5 -27.5t47.5 -10.5zM207 275q12 0 24 2t22 6.5t16.5 10.5t6.5 14q0 12 -16.5 19.5t-39.5 7.5q-26 0 -47 -9t-21 -24 q0 -13 17.5 -20t37.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 430,
    d: "M133 -6q-45 0 -82 15t-60 44l78 77q14 -16 37.5 -24.5t52.5 -8.5q43 0 72.5 17.5t37.5 49.5q-17 -11 -45 -15.5t-51 -4.5q-71 0 -112 34.5t-41 87.5q0 36 18 68.5t49 57t71 38.5t85 14q72 0 109.5 -42.5t37.5 -118.5q0 -63 -18.5 -116t-52.5 -91.5t-81.5 -60 t-104.5 -21.5zM198 239q18 0 35 4.5t30 12t21 17.5t8 22q0 20 -20.5 34.5t-51.5 14.5q-18 0 -35 -5t-30 -13.5t-21 -19t-8 -22.5q0 -20 20.5 -32.5t51.5 -12.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0135",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "X.sc",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "A.sc",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u01FF",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u01FE",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xF8",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xD8",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0135",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "X.sc",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.alt",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "A.sc",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u01FF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0135",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012D",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0128",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEF",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "x",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "X",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "V",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "Y.sc",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "X.sc",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "W.sc",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "V.sc",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0166",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0135",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0127",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0126",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEF",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEE",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "V",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0135",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "eight.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "Z.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "W.alt",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012D",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEF",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "X",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "V",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 297
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0135",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u01FF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xF8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0129",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xF0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xEF",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0129",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xEF",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0142",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0135",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012D",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xEF",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xEE",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0135",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012D",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0127",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEF",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEE",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u0129",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\xEF",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0129",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xEF",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0135",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0129",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xEF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xEE",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01FF",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01FE",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012D",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0127",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF8",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEF",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEC",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD8",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u0129",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\xEF",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u0129",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\xEF",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0142",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "y.alt",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEF",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "}",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "v",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "]",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "5",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0142",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "4",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ")",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u01FF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0129",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0135",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EBD",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0161",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0135",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012D",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0127",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u012D",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xEE",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0135",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0127",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA6",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "|",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\\\\\\\",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "*",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u017E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0161",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0135",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0127",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEF",
    k: -87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEE",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEC",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "t.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0135",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012D",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0127",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEF",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA6",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "4",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: ")",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u017E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0161",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0135",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012D",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0127",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0103",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFC",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEE",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEC",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0135",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012D",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEF",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEE",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0135",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012D",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0129",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEF",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEE",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "X.sc",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "A.sc",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u01FE",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "x",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "X",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xEF",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u0142",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0142",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xEE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -126
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u0142",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "}",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "]",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: ")",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012D",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEF",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEE",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "t.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "A.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u01FE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u01F5",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u018F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0123",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0121",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u011F",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u011D",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "x",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "X",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "\u0129",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "\xEF",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "t.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "A.sc",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "X",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "\u201D",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "\u2019",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "\xA6",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: "|",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCF",
    u2: ")",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "W.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u2122",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1EF8",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1EF2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E84",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E82",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E80",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u1E6C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u021A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0178",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0176",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0174",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0164",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0162",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xDD",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "|",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\\\\\\\\",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "Y",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "X",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "W",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "T",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ")",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "X.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xA6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "}",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "|",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "]",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xED",
    u2: "\xA6",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    g2: "l.alt",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    g2: "j.alt",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2122",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2120",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u201D",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u201C",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2019",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2018",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u0133",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xFE",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xBA",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xA6",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "}",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "|",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "l",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "k",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "j",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "i",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "h",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "b",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "?",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "*",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: ")",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "'",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\"",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    g2: "l.alt",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    g2: "j.alt",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2122",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2120",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0133",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xFE",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xDF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xBA",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xAA",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\xA6",
    k: -67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "|",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "l",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "k",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "i",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "h",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "b",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "]",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\\\\\\\\",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "?",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "*",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: ")",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "'",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "&",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\"",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "!",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "w",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "y",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "g",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "y.alt",
    k: -105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "w.alt",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "u.alt",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "t.alt",
    k: -91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "l.alt",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "j.alt",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "a.alt2",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_f_l",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_f_i",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_l",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_i",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "f_f",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2120",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u203A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201C",
    k: -129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2018",
    k: -129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u017E",
    k: -144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u016F",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFA",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xF0",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xE6",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xBB",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xBA",
    k: -114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xAE",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xAA",
    k: -139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA9",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -209
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -168
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -204
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "z",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "y",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "x",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "w",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "v",
    k: -103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "u",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "t",
    k: -110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "r",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "p",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "n",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "m",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "l",
    k: -170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "j",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "f",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "?",
    k: -110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ";",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ":",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -192
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "'",
    k: -166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "&",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\"",
    k: -166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "!",
    k: -141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: " ",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\xA6",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "|",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "*",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u0142",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0125",
    u2: "\u2122",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0125",
    u2: "*",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "Y.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "X.sc",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "W.sc",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "V.sc",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "*",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    g2: "l.alt",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    g2: "j.alt",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2120",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201C",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2018",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0133",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xFE",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xBA",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xAA",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "l",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "k",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "j",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "i",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "h",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "b",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "'",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\"",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "!",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\xA6",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "|",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\\\\\\\\",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: ")",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012E",
    u2: "j",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    g2: "l.alt",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    g2: "j.alt",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2120",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u201D",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u201C",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2019",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2018",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u0133",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xFE",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xBA",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\xA6",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "}",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "|",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "l",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "k",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "i",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "h",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "b",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "]",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "?",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "*",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "'",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\"",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u01FE",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\xD8",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "Y.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2122",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2120",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201C",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2018",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1EF8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1EF2",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E84",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E82",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E80",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u1E6C",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u021A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0178",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0176",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0174",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0164",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0162",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xDD",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xAA",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xA6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "Y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "W",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "T",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "*",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "'",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\"",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "t.alt",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "l.alt",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "j.alt",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "f_l",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2120",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201D",
    k: -124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201C",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2019",
    k: -124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2018",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u017E",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0161",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0148",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0133",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u010D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xFE",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xF0",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xDF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xBA",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xAE",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xAA",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA9",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -153
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "x",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "t",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "l",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "k",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "j",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "i",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "h",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "f",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "b",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "?",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "*",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "'",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "&",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\"",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "!",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: " ",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0166",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\uFB06",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u017C",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u017A",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\xAE",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\xA9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "z",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEE",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    g2: "t.alt",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    g2: "l.alt",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    g2: "j.alt",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2122",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2120",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201D",
    k: -118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201C",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2019",
    k: -118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2018",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0165",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0161",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0148",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u0133",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u011B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u010D",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xFE",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xF0",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xED",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xE4",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xDF",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xBA",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xAE",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xAA",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xA9",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xA6",
    k: -148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "}",
    k: -108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "|",
    k: -143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "t",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "l",
    k: -109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "k",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "j",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "i",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "h",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "b",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "]",
    k: -116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\\\\\\\\",
    k: -127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "?",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "*",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: ")",
    k: -132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "'",
    k: -105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "&",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\"",
    k: -105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "!",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "T.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2026",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1E84",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1E82",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1E80",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FC",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0174",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0134",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC6",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA6",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "|",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\\\\\\\\",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "W",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "J",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "*",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u01FE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD8",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "W.alt",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1EF8",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1EF2",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1E84",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1E82",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u1E80",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0178",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0176",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0174",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xDD",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\\\\\\\\",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "Y",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "X",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "W",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "V",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: ")",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "w",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEE",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0129",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEF",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0135",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0128",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEF",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEE",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xCF",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0135",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0129",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEF",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0135",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0128",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEF",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEE",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xCF",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0135",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0135",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xEF",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -183
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0142",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0129",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0129",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB06",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: ")",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xBA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0142",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0129",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\xEF",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "/",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: ")",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u2122",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\xA6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "]",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: ")",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xBA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\xBA",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "t.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u2122",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0135",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012D",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0127",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEF",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEE",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xED",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEC",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA6",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "|",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "x",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\\\\\\\\",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: ")",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\xBA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "S.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\xBA",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: ")",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\xBA",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xBA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c_t",
    u2: "\u0149",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xEE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lnum",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lnum",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    u2: "\xB0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u0135",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xEF",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xEE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xF7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "eight.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: ")",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lnum",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0142",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "slash",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "four",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "parenright",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "two",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "AE,AEacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T.sc",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V.sc",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W.sc",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y.sc",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "AE,AEacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X.sc",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "bar",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "backslash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "slash",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "backslash",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "brokenbar",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "four",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "parenright",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "trademark",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "two",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "braceright",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "bracketright",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "parenright",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "bar",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "backslash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "four",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "parenright",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "AE,AEacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "asterisk",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "backslash",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "bar",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "brokenbar",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "parenright",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "trademark",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "asterisk",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "backslash",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "bar",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "brokenbar",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "parenright",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "quoteright,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "trademark",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "bracketright",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "colon,semicolon",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "ae,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "asterisk",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "backslash",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "bar",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "brokenbar",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "parenright",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "quoteright,quotedblright",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "trademark",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Y.sc",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "eth",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "asterisk",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quoteright,quotedblright",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "AE,AEacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "bar",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "trademark",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "parenright",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "eth",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "x",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "bar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "asterisk",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "trademark",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "asterisk",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ordmasculine",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "backslash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "AE,AEacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "ordmasculine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "AE,AEacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "AE,AEacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "AE,AEacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "AE,AEacute",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "AE,AEacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "AE,AEacute",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -29
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayBlackItalic);
export default __webpack_public_path__ + "static/media/Raleway-BlackItalic.23eb22a54374db75c0463001b37e9dd0.svg";
export { ForwardRef as ReactComponent };